export enum Language {
  ENGLISH = "en",
  SPANISH = "es",
  PORTUGUESE = "pt",
}

interface Dictionary {
  [key: string]: {
    [key in Language]: string;
  };
}

export const dictionary: Dictionary = {
  // LANDING PAGE
  "fluxi-is-free": {
    [Language.ENGLISH]: "Fluxi is 100% free",
    [Language.SPANISH]: "Fluxi es 100% gratis",
    [Language.PORTUGUESE]: "Fluxi é 100% gratuito",
  },
  "add-your-product-with-ia": {
    [Language.ENGLISH]:
      "Add your product, and Fluxi creates your sales funnel in seconds",
    [Language.SPANISH]:
      "Agrega tu producto, y Fluxi crea tu embudo de ventas en segundos",
    [Language.PORTUGUESE]:
      "Adicione seu produto, e o Fluxi cria seu funil de vendas em segundos",
  },
  "fluxi-complementary-offers": {
    [Language.ENGLISH]:
      "Fluxi´s AI finds complementary offers that maximize your average sales ticket with automatic upsells, downsells, and bump offers.",
    [Language.SPANISH]:
      "Fluxi en segundos, diseña y optimiza embudos de venta de altísima conversión, creando  ofertas complementarias",
    [Language.PORTUGUESE]:
      "A IA do Fluxi encontra ofertas complementares que maximizam seu ticket médio com upsells, downsells e bump offers automáticos.",
  },
  "register-now": {
    [Language.ENGLISH]: "Register now!",
    [Language.SPANISH]: "Regístrate ahora",
    [Language.PORTUGUESE]: "Registre-se agora!",
  },
  "try-now": {
    [Language.ENGLISH]: "Try now!",
    [Language.SPANISH]: "Prueba ahora",
    [Language.PORTUGUESE]: "Experimente agora!",
  },
  "sign-up-now": {
    [Language.ENGLISH]: "Sign up now!",
    [Language.SPANISH]: "¡Regístrate ahora!",
    [Language.PORTUGUESE]: "Cadastre-se agora!",
  },
  "continuous-optimization": {
    [Language.ENGLISH]:
      "Continuous optimization based on your buyers real behavior.",
    [Language.SPANISH]:
      "Fluxi crea copys persuasivos basados en investigación en tiempo real del cliente de tu producto.",
    [Language.PORTUGUESE]:
      "Otimização contínua baseada no comportamento real dos seus compradores.",
  },
  "fluxi-soon": {
    [Language.ENGLISH]:
      "Fluxi is coming soon. Join our waitlist and get priority access before anyone else.",
    [Language.SPANISH]:
      "Fluxi llegará pronto. Únete a nuestra lista de espera y obtén acceso prioritario antes que nadie.",
    [Language.PORTUGUESE]:
      "Fluxi está chegando. Junte-se à nossa lista de espera e tenha acesso prioritário antes de todos.",
  },
  "self-optimizing": {
    [Language.ENGLISH]: "Self-optimizing pages with AI",
    [Language.SPANISH]: "Páginas autooptimizadas con IA",
    [Language.PORTUGUESE]: "Páginas auto-otimizadas com IA",
  },
  "works-item-1": {
    [Language.ENGLISH]: "Works with any product you want to boost sales for",
    [Language.SPANISH]:
      "Funciona con cualquier producto que quieras aumentar las ventas",
    [Language.PORTUGUESE]:
      "Funciona com qualquer produto que você queira aumentar as vendas",
  },
  "works-item-2": {
    [Language.ENGLISH]:
      "Smart and effective upsells, downsells, and bump offers for each product",
    [Language.SPANISH]:
      "Upsells, downsells y ofertas de aumento inteligentes y efectivas para cada producto",
    [Language.PORTUGUESE]:
      "Upsells, downsells e bump offers inteligentes e eficazes para cada produto",
  },
  "works-item-3": {
    [Language.ENGLISH]: "Create and edit over 30 AI-optimized sales funnels",
    [Language.SPANISH]:
      "Crea y edita más de 30 embudos de ventas optimizados con IA",
    [Language.PORTUGUESE]:
      "Crie e edite mais de 30 funis de vendas otimizados com IA",
  },
  "works-item-4": {
    [Language.ENGLISH]: "Personalized AI digital gifts, free for each funnel",
    [Language.SPANISH]:
      "Gastos digitales personalizados con IA, gratis para cada embudo",
    [Language.PORTUGUESE]:
      "Brindes digitais personalizados com IA, grátis para cada funil",
  },
  "want-your-products": {
    [Language.ENGLISH]: "Want your products to sell like magic?",
    [Language.SPANISH]:
      "¿Quieres que tus productos se vendan como por arte de magia?",
    [Language.PORTUGUESE]: "Quer que seus produtos vendam como mágica?",
  },
  "fluxi-is-perfect": {
    [Language.ENGLISH]: "Fluxi is perfect for you",
    [Language.SPANISH]: "Fluxi es perfecto para ti",
    [Language.PORTUGUESE]: "Fluxi é perfeito para você",
  },
  "for-entrepreneurs": {
    [Language.ENGLISH]: "For entrepreneurs chasing",
    [Language.SPANISH]: "Para emprendedores que persiguen",
    [Language.PORTUGUESE]: "Para empreendedores que buscam",
  },
  "remarkable-sales-conversion": {
    [Language.ENGLISH]: "remarkable sales conversion results",
    [Language.SPANISH]: "resultados de conversión de ventas notables",
    [Language.PORTUGUESE]: "resultados notáveis de conversão de vendas",
  },
  "with-the-power": {
    [Language.ENGLISH]: "with the power of AI",
    [Language.SPANISH]: "con el poder de IA",
    [Language.PORTUGUESE]: "com o poder da IA",
  },
  "we-turn-your-wishes": {
    [Language.ENGLISH]: "We turn your wishes into sales",
    [Language.SPANISH]: "Convertimos tus deseos en ventas",
    [Language.PORTUGUESE]: "Transformamos seus desejos em vendas",
  },
  "start-boosting-your-sales": {
    [Language.ENGLISH]: "Start boosting your sales significantly with Fluxi",
    [Language.SPANISH]:
      "Comienza a aumentar tus ventas significativamente con Fluxi",
    [Language.PORTUGUESE]:
      "Comece a aumentar suas vendas significativamente com o Fluxi",
  },
  faqs: {
    [Language.ENGLISH]: "FAQs",
    [Language.SPANISH]: "Preguntas frecuentes",
    [Language.PORTUGUESE]: "Perguntas frequentes",
  },
  "question-1": {
    [Language.ENGLISH]: "How does Fluxi work?",
    [Language.SPANISH]: "¿Cómo funciona Fluxi?",
    [Language.PORTUGUESE]: "Como o Fluxi funciona?",
  },
  "answer-1": {
    [Language.ENGLISH]:
      "Fluxi uses artificial intelligence to create highly effective sales funnels in seconds. Simply add your product, and Fluxi automatically generates upsells, downsells, and bump offers optimized to maximize your revenue, with no technical expertise required.",
    [Language.SPANISH]:
      "Fluxi utiliza inteligencia artificial para crear embudos de ventas altamente efectivos en segundos. Simplemente agrega tu producto, y Fluxi automáticamente genera upsells, downsells y ofertas de aumento optimizadas para maximizar tus ingresos, sin necesidad de experiencia técnica.",
    [Language.PORTUGUESE]:
      "O Fluxi usa inteligência artificial para criar funis de vendas altamente eficazes em segundos. Basta adicionar seu produto, e o Fluxi gera automaticamente upsells, downsells e bump offers otimizados para maximizar sua receita, sem necessidade de experiência técnica.",
  },
  "question-2": {
    [Language.ENGLISH]: "Do I need any experience to use Fluxi?",
    [Language.SPANISH]: "¿Necesito experiencia para usar Fluxi?",
    [Language.PORTUGUESE]: "Preciso de experiência para usar o Fluxi?",
  },
  "answer-2": {
    [Language.ENGLISH]:
      "No, Fluxi is designed to be easy to use. You don't need technical experience or sales knowledge. The platform automatically creates funnels tailored to your product, helping you boost sales without hassle.",
    [Language.SPANISH]:
      "No, Fluxi está diseñado para ser fácil de usar. No necesitas experiencia técnica o conocimientos de ventas. La plataforma automáticamente crea embudos adaptados a tu producto, ayudándote a aumentar las ventas sin complicaciones.",
    [Language.PORTUGUESE]:
      "Não, o Fluxi foi projetado para ser fácil de usar. Você não precisa de experiência técnica ou conhecimento em vendas. A plataforma cria automaticamente funis adaptados ao seu produto, ajudando você a aumentar as vendas sem complicações.",
  },
  "question-3": {
    [Language.ENGLISH]:
      "How long does it take to set up a sales funnel in Fluxi?",
    [Language.SPANISH]:
      "¿Cuánto tiempo toma configurar un embudo de ventas en Fluxi?",
    [Language.PORTUGUESE]:
      "Quanto tempo leva para configurar um funil de vendas no Fluxi?",
  },
  "answer-3": {
    [Language.ENGLISH]:
      "Setting up a sales funnel with Fluxi is instant. Just input your product information, and the AI will generate an optimized funnel in seconds, ready to start increasing your revenue.",
    [Language.SPANISH]:
      "Configurar un embudo de ventas con Fluxi es instantáneo. Simplemente ingresa la información de tu producto, y la IA generará un embudo optimizado en segundos, listo para comenzar a aumentar tus ingresos.",
    [Language.PORTUGUESE]:
      "Configurar um funil de vendas com o Fluxi é instantâneo. Basta inserir as informações do seu produto, e a IA gerará um funil otimizado em segundos, pronto para começar a aumentar sua receita.",
  },
  "question-4": {
    [Language.ENGLISH]:
      "Does Fluxi keep optimizing my funnel after it's set up?",
    [Language.SPANISH]:
      "¿Fluxi sigue optimizando mi embudo después de configurarlo?",
    [Language.PORTUGUESE]:
      "O Fluxi continua otimizando meu funil depois de configurado?",
  },
  "answer-4": {
    [Language.ENGLISH]:
      "Yes, Fluxi not only creates your funnel but also continuously optimizes it based on performance data. The AI adjusts offers, content, and structure to continually improve conversion rates and maximize your profits.",
    [Language.SPANISH]:
      "Sí, Fluxi no solo crea tu embudo sino que también lo optimiza continuamente basado en datos de rendimiento. La IA ajusta ofertas, contenido y estructura para mejorar continuamente las tasas de conversión y maximizar tus ganancias.",
    [Language.PORTUGUESE]:
      "Sim, o Fluxi não apenas cria seu funil, mas também o otimiza continuamente com base em dados de desempenho. A IA ajusta ofertas, conteúdo e estrutura para melhorar continuamente as taxas de conversão e maximizar seus lucros.",
  },
  "its-like-having": {
    [Language.ENGLISH]:
      "It's like having an expert sales optimization team working 24/7",
    [Language.SPANISH]:
      "Es como tener un equipo de optimización de ventas experto trabajando 24/7",
    [Language.PORTUGUESE]:
      "É como ter uma equipe especialista em otimização de vendas trabalhando 24/7",
  },
  "try-fluxi-for-free": {
    [Language.ENGLISH]: "Try Fluxi for free!",
    [Language.SPANISH]: "Prueba Fluxi gratis!",
    [Language.PORTUGUESE]: "Experimente o Fluxi grátis!",
  },
  "sales-like-magic": {
    [Language.ENGLISH]: "Sales like magic",
    [Language.SPANISH]: "Ventas como por arte de magia",
    [Language.PORTUGUESE]: "Vendas como mágica",
  },
  "start-for-free-now": {
    [Language.ENGLISH]: "Start for free now!",
    [Language.SPANISH]: "Comienza gratis ahora!",
    [Language.PORTUGUESE]: "Comece grátis agora!",
  },
  "made-with-passion-by-fluxi": {
    [Language.ENGLISH]: "Made with passion by Fluxi",
    [Language.SPANISH]: "Hecho con pasión por Fluxi",
    [Language.PORTUGUESE]: "Feito com paixão pelo Fluxi",
  },
  copyright: {
    [Language.ENGLISH]: "Copyright © 2025. All rights reserved.",
    [Language.SPANISH]:
      "Derechos de autor © 2025. Todos los derechos reservados.",
    [Language.PORTUGUESE]:
      "Direitos autorais © 2025. Todos os direitos reservados.",
  },
  // HOME PAGE
  "greeting-morning": {
    [Language.ENGLISH]: "Good morning",
    [Language.SPANISH]: "Buenos días",
    [Language.PORTUGUESE]: "Bom dia",
  },
  "greeting-afternoon": {
    [Language.ENGLISH]: "Good afternoon",
    [Language.SPANISH]: "Buenas tardes",
    [Language.PORTUGUESE]: "Boa tarde",
  },
  "greeting-night": {
    [Language.ENGLISH]: "Good night",
    [Language.SPANISH]: "Buenas noches",
    [Language.PORTUGUESE]: "Boa noite",
  },
  "question-home": {
    [Language.ENGLISH]: "What do you want to do today?",
    [Language.SPANISH]: "¿Qué quieres hacer hoy?",
    [Language.PORTUGUESE]: "O que você quer fazer hoje?",
  },
  "create-new-funnel": {
    [Language.ENGLISH]: "Create a new funnel",
    [Language.SPANISH]: "Crear un nuevo embudo",
    [Language.PORTUGUESE]: "Criar um novo funil",
  },
  "see-my-sales": {
    [Language.ENGLISH]: "See my sales",
    [Language.SPANISH]: "Ver mis ventas",
    [Language.PORTUGUESE]: "Ver minhas vendas",
  },
  "see-my-funnels": {
    [Language.ENGLISH]: "See my funnels",
    [Language.SPANISH]: "Ver mis embudos",
    [Language.PORTUGUESE]: "Ver meus funis",
  },
  "see-my-ads": {
    [Language.ENGLISH]: "See my ads",
    [Language.SPANISH]: "Ver mis anuncios",
    [Language.PORTUGUESE]: "Ver meus anúncios",
  },

  // SIDEBAR
  home: {
    [Language.ENGLISH]: "Home",
    [Language.SPANISH]: "Inicio",
    [Language.PORTUGUESE]: "Início",
  },
  orders: {
    [Language.ENGLISH]: "Orders",
    [Language.SPANISH]: "Ordenes",
    [Language.PORTUGUESE]: "Pedidos",
  },
  products: {
    [Language.ENGLISH]: "Products",
    [Language.SPANISH]: "Productos",
    [Language.PORTUGUESE]: "Produtos",
  },
  ads: {
    [Language.ENGLISH]: "Ads",
    [Language.SPANISH]: "Anuncios",
    [Language.PORTUGUESE]: "Anúncios",
  },
  funnels: {
    [Language.ENGLISH]: "Funnels",
    [Language.SPANISH]: "Embudos",
    [Language.PORTUGUESE]: "Funis",
  },
  settings: {
    [Language.ENGLISH]: "Settings",
    [Language.SPANISH]: "Configuración",
    [Language.PORTUGUESE]: "Configurações",
  },

  training: {
    [Language.ENGLISH]: "Training",
    [Language.SPANISH]: "Entrenamiento",
    [Language.PORTUGUESE]: "Treinamento",
  },

  "come-ready": {
    [Language.ENGLISH]:
      "Com'n you are ready to get rich, do your first funnel now!",
    [Language.SPANISH]:
      "Vamos, listo para ganar dinero, crea tu primer embudo ahora!",
    [Language.PORTUGUESE]:
      "Vamos, você está pronto para ficar rico, crie seu primeiro funil agora!",
  },

  // ORDERS PAGE
  "undo-changes": {
    [Language.ENGLISH]: "Undo changes",
    [Language.SPANISH]: "Deshacer cambios",
    [Language.PORTUGUESE]: "Desfazer alterações",
  },
  "save-changes": {
    [Language.ENGLISH]: "Save changes",
    [Language.SPANISH]: "Guardar cambios",
    [Language.PORTUGUESE]: "Salvar alterações",
  },
  "filter-by-date": {
    [Language.ENGLISH]: "Filter by date",
    [Language.SPANISH]: "Filtrar por fecha",
    [Language.PORTUGUESE]: "Filtrar por data",
  },
  "relative-dates": {
    [Language.ENGLISH]: "Relative dates",
    [Language.SPANISH]: "Fechas relativas",
    [Language.PORTUGUESE]: "Datas relativas",
  },
  "specific-dates": {
    [Language.ENGLISH]: "Specific dates",
    [Language.SPANISH]: "Fechas específicas",
    [Language.PORTUGUESE]: "Datas específicas",
  },
  today: {
    [Language.ENGLISH]: "Today",
    [Language.SPANISH]: "Hoy",
    [Language.PORTUGUESE]: "Hoje",
  },
  yesterday: {
    [Language.ENGLISH]: "Yesterday",
    [Language.SPANISH]: "Ayer",
    [Language.PORTUGUESE]: "Ontem",
  },
  "this-month": {
    [Language.ENGLISH]: "This month",
    [Language.SPANISH]: "Este mes",
    [Language.PORTUGUESE]: "Este mês",
  },
  "last-month": {
    [Language.ENGLISH]: "Last month",
    [Language.SPANISH]: "Mes pasado",
    [Language.PORTUGUESE]: "Mês passado",
  },
  "start-date": {
    [Language.ENGLISH]: "Start date",
    [Language.SPANISH]: "Fecha inicial",
    [Language.PORTUGUESE]: "Data inicial",
  },
  "end-date": {
    [Language.ENGLISH]: "End date",
    [Language.SPANISH]: "Fecha final",
    [Language.PORTUGUESE]: "Data final",
  },
  "apply-filter": {
    [Language.ENGLISH]: "Apply filter",
    [Language.SPANISH]: "Aplicar filtro",
    [Language.PORTUGUESE]: "Aplicar filtro",
  },
  "no-orders-found": {
    [Language.ENGLISH]: "No orders found",
    [Language.SPANISH]: "No se encontraron órdenes",
    [Language.PORTUGUESE]: "Nenhuma ordem encontrada",
  },
  "try-different-filters": {
    [Language.ENGLISH]: "Try different filters or date range",
    [Language.SPANISH]: "Intenta con diferentes filtros o rango de fechas",
    [Language.PORTUGUESE]: "Tente diferentes filtros ou intervalo de datas",
  },
  "search-product": {
    [Language.ENGLISH]: "Search product...",
    [Language.SPANISH]: "Buscar producto...",
    [Language.PORTUGUESE]: "Buscar produto...",
  },
  "sales-orders": {
    [Language.ENGLISH]: "Sales orders",
    [Language.SPANISH]: "Ordenes",
    [Language.PORTUGUESE]: "Pedidos",
  },
  // FILTERS
  all: {
    [Language.ENGLISH]: "All",
    [Language.SPANISH]: "Todos",
    [Language.PORTUGUESE]: "Todos",
  },
  unfulfilled: {
    [Language.ENGLISH]: "Unfulfilled",
    [Language.SPANISH]: "No entregados",
    [Language.PORTUGUESE]: "Não entregues",
  },
  fulfilled: {
    [Language.ENGLISH]: "Fulfilled",
    [Language.SPANISH]: "Entregados",
    [Language.PORTUGUESE]: "Entregues",
  },
  pending: {
    [Language.ENGLISH]: "Pending",
    [Language.SPANISH]: "Pendientes",
    [Language.PORTUGUESE]: "Pendentes",
  },
  paid: {
    [Language.ENGLISH]: "Paid",
    [Language.SPANISH]: "Pagados",
    [Language.PORTUGUESE]: "Pagados",
  },
  unpaid: {
    [Language.ENGLISH]: "Unpaid",
    [Language.SPANISH]: "No pagados",
    [Language.PORTUGUESE]: "Não pagados",
  },
  // SALES STATS
  "total-sales": {
    [Language.ENGLISH]: "Total sales",
    [Language.SPANISH]: "Total de ventas",
    [Language.PORTUGUESE]: "Total de vendas",
  },
  "products-sold": {
    [Language.ENGLISH]: "Products sold",
    [Language.SPANISH]: "Productos vendidos",
    [Language.PORTUGUESE]: "Produtos vendidos",
  },
  buyers: {
    [Language.ENGLISH]: "Buyers",
    [Language.SPANISH]: "Compradores",
    [Language.PORTUGUESE]: "Compradores",
  },
  // SALES TABLE
  downloading: {
    [Language.ENGLISH]: "Downloading...",
    [Language.SPANISH]: "Descargando...",
    [Language.PORTUGUESE]: "Baixando...",
  },
  "download-orders": {
    [Language.ENGLISH]: "Download orders",
    [Language.SPANISH]: "Descargar ordenes",
    [Language.PORTUGUESE]: "Baixar pedidos",
  },
  date: {
    [Language.ENGLISH]: "Date",
    [Language.SPANISH]: "Fecha",
    [Language.PORTUGUESE]: "Data",
  },
  "date-and-time": {
    [Language.ENGLISH]: "Date and time",
    [Language.SPANISH]: "Fecha y hora",
    [Language.PORTUGUESE]: "Data e hora",
  },
  "order-number": {
    [Language.ENGLISH]: "Order number",
    [Language.SPANISH]: "Número de orden",
    [Language.PORTUGUESE]: "Número de pedido",
  },
  customer: {
    [Language.ENGLISH]: "Customer",
    [Language.SPANISH]: "Cliente",
    [Language.PORTUGUESE]: "Cliente",
  },
  total: {
    [Language.ENGLISH]: "Total",
    [Language.SPANISH]: "Total",
    [Language.PORTUGUESE]: "Total",
  },
  channel: {
    [Language.ENGLISH]: "Channel",
    [Language.SPANISH]: "Canal",
    [Language.PORTUGUESE]: "Canal",
  },
  payment: {
    [Language.ENGLISH]: "Payment",
    [Language.SPANISH]: "Pago",
    [Language.PORTUGUESE]: "Pagamento",
  },
  "payment-method": {
    [Language.ENGLISH]: "Payment method",
    [Language.SPANISH]: "Método de pago",
    [Language.PORTUGUESE]: "Método de pagamento",
  },
  status: {
    [Language.ENGLISH]: "Status",
    [Language.SPANISH]: "Estado",
    [Language.PORTUGUESE]: "Estado",
  },
  "payment-status": {
    [Language.ENGLISH]: "Payment status",
    [Language.SPANISH]: "Estado de pago",
    [Language.PORTUGUESE]: "Estado de pagamento",
  },
  fulfillment: {
    [Language.ENGLISH]: "Fulfillment",
    [Language.SPANISH]: "Envío",
    [Language.PORTUGUESE]: "Envio",
  },
  "fulfillment-status": {
    [Language.ENGLISH]: "Fulfillment status",
    [Language.SPANISH]: "Estado de envío",
    [Language.PORTUGUESE]: "Estado de envio",
  },
  items: {
    [Language.ENGLISH]: "Items",
    [Language.SPANISH]: "Unidades",
    [Language.PORTUGUESE]: "Unidades",
  },
  actions: {
    [Language.ENGLISH]: "Actions",
    [Language.SPANISH]: "Acciones",
    [Language.PORTUGUESE]: "Ações",
  },
  "paid-state": {
    [Language.ENGLISH]: "Paid",
    [Language.SPANISH]: "Pagado",
    [Language.PORTUGUESE]: "Pago",
  },
  "pending-state": {
    [Language.ENGLISH]: "Pending",
    [Language.SPANISH]: "Pendiente",
    [Language.PORTUGUESE]: "Pendente",
  },
  "unpaid-state": {
    [Language.ENGLISH]: "Unpaid",
    [Language.SPANISH]: "No pagado",
    [Language.PORTUGUESE]: "Não pago",
  },
  "fulfilled-state": {
    [Language.ENGLISH]: "Fulfilled",
    [Language.SPANISH]: "Entregado",
    [Language.PORTUGUESE]: "Entregado",
  },
  "unfulfilled-state": {
    [Language.ENGLISH]: "Unfulfilled",
    [Language.SPANISH]: "No entregado",
    [Language.PORTUGUESE]: "Não entregado",
  },
  view: {
    [Language.ENGLISH]: "View",
    [Language.SPANISH]: "Ver",
    [Language.PORTUGUESE]: "Ver",
  },
  "view-details": {
    [Language.ENGLISH]: "View Details",
    [Language.SPANISH]: "Ver Detalles",
    [Language.PORTUGUESE]: "Ver Detalhes",
  },

  // ORDER DETAILS PAGE
  "order-details": {
    [Language.ENGLISH]: "Order details",
    [Language.SPANISH]: "Detalles de la orden",
    [Language.PORTUGUESE]: "Detalhes da ordem",
  },
  priority: {
    [Language.ENGLISH]: "Priority",
    [Language.SPANISH]: "Prioridad",
    [Language.PORTUGUESE]: "Prioridade",
  },
  //   "fulfill-item": {
  //     [Language.ENGLISH]: "Fulfill item",
  //     [Language.SPANISH]: "Entregar item",
  //   },
  //   "unfulfill-item": {
  //     [Language.ENGLISH]: "Unfulfill item",
  //     [Language.SPANISH]: "No entregar item",
  //   },
  "fulfill-item": {
    [Language.ENGLISH]: "Mark as delivered",
    [Language.SPANISH]: "Marcar como entregado",
    [Language.PORTUGUESE]: "Marcar como entregado",
  },
  "unfulfill-item": {
    [Language.ENGLISH]: "Mark as not delivered",
    [Language.SPANISH]: "Marcar como no entregado",
    [Language.PORTUGUESE]: "Marcar como não entregado",
  },
  "first-time-customer": {
    [Language.ENGLISH]: "First time customer",
    [Language.SPANISH]: "Primer pedido",
    [Language.PORTUGUESE]: "Primeiro pedido",
  },
  "customer-details": {
    [Language.ENGLISH]: "Customer details",
    [Language.SPANISH]: "Detalles del cliente",
    [Language.PORTUGUESE]: "Detalhes do cliente",
  },
  "payment-details": {
    [Language.ENGLISH]: "Payment details",
    [Language.SPANISH]: "Detalles de pago",
    [Language.PORTUGUESE]: "Detalhes de pagamento",
  },
  subtotal: {
    [Language.ENGLISH]: "Subtotal",
    [Language.SPANISH]: "Subtotal",
    [Language.PORTUGUESE]: "Subtotal",
  },
  "paid-on": {
    [Language.ENGLISH]: "Paid on",
    [Language.SPANISH]: "Pagado el",
    [Language.PORTUGUESE]: "Pago em",
  },
  "paid-with": {
    [Language.ENGLISH]: "Paid with",
    [Language.SPANISH]: "Pagado con",
    [Language.PORTUGUESE]: "Pago com",
  },
  "shipping-address": {
    [Language.ENGLISH]: "Shipping address",
    [Language.SPANISH]: "Dirección de envío",
    [Language.PORTUGUESE]: "Endereço de envio",
  },

  // PRODUCTS PAGE
  product: {
    [Language.ENGLISH]: "Product",
    [Language.SPANISH]: "Producto",
    [Language.PORTUGUESE]: "Produto",
  },
  price: {
    [Language.ENGLISH]: "Price",
    [Language.SPANISH]: "Precio",
    [Language.PORTUGUESE]: "Preço",
  },
  "last-updated": {
    [Language.ENGLISH]: "Last updated",
    [Language.SPANISH]: "Última actualización",
    [Language.PORTUGUESE]: "Última atualização",
  },

  // ADS PAGE
  "please-fill-all-the-fields": {
    [Language.ENGLISH]: "Please fill all the fields",
    [Language.SPANISH]: "Por favor, completa todos los campos",
    [Language.PORTUGUESE]: "Por favor, complete todos os campos",
  },
  "failed-to-generate-narrative": {
    [Language.ENGLISH]: "Failed to generate narrative",
    [Language.SPANISH]: "Error al generar la narrativa",
    [Language.PORTUGUESE]: "Erro ao gerar a narrativa",
  },
  "narrative-generated-successfully": {
    [Language.ENGLISH]: "Narrative generated successfully",
    [Language.SPANISH]: "Narrativa generada correctamente",
    [Language.PORTUGUESE]: "Narrativa gerada com sucesso",
  },
  "your-ads": {
    [Language.ENGLISH]: "Your ads",
    [Language.SPANISH]: "Tus anuncios",
    [Language.PORTUGUESE]: "Seus anúncios",
  },
  "your-generated-narratives-will-appear-here": {
    [Language.ENGLISH]: "Your generated narratives will appear here.",
    [Language.SPANISH]: "Tus narrativas generadas aparecerán aquí.",
    [Language.PORTUGUESE]: "Suas narrativas geradas aparecerão aqui.",
  },
  "start-filling-the-form-on-the-right": {
    [Language.ENGLISH]: "Start filling the form on the right.",
    [Language.SPANISH]: "Comienza llenando el formulario de la derecha.",
    [Language.PORTUGUESE]: "Comece a preencher o formulário à direita.",
  },
  "no-narratives-yet": {
    [Language.ENGLISH]: "No narratives yet",
    [Language.SPANISH]: "No hay narrativas aún",
    [Language.PORTUGUESE]: "Nenhuma narrativa ainda",
  },
  "no-narratives-found-for-this-filter": {
    [Language.ENGLISH]: "No narratives found for this filter.",
    [Language.SPANISH]: "No se encontraron narrativas para este filtro.",
    [Language.PORTUGUESE]: "Nenhuma narrativa encontrada para este filtro.",
  },
  "create-your-scripts": {
    [Language.ENGLISH]: "Create your scripts",
    [Language.SPANISH]: "Crear tus guiones",
    [Language.PORTUGUESE]: "Criar seus guias",
  },
  "product-name": {
    [Language.ENGLISH]: "Product name",
    [Language.SPANISH]: "Nombre del producto",
    [Language.PORTUGUESE]: "Nome do produto",
  },
  "product-description": {
    [Language.ENGLISH]: "Product description",
    [Language.SPANISH]: "Descripción del producto",
    [Language.PORTUGUESE]: "Descrição do produto",
  },
  "sale-angle": {
    [Language.ENGLISH]: "Sale angle",
    [Language.SPANISH]: "Ángulo de venta",
    [Language.PORTUGUESE]: "Ângulo de venda",
  },
  "product-name-placeholder": {
    [Language.ENGLISH]: "Product name",
    [Language.SPANISH]: "Nombre del producto",
    [Language.PORTUGUESE]: "Nome do produto",
  },
  "product-description-placeholder": {
    [Language.ENGLISH]: "Product description",
    [Language.SPANISH]: "Descripción del producto",
    [Language.PORTUGUESE]: "Descrição do produto",
  },
  "sale-angle-placeholder": {
    [Language.ENGLISH]: "Sale angle",
    [Language.SPANISH]: "Ángulo de venta",
    [Language.PORTUGUESE]: "Ângulo de venda",
  },
  "podcast-style": {
    [Language.ENGLISH]: "Podcast style",
    [Language.SPANISH]: "Estilo podcast",
    [Language.PORTUGUESE]: "Estilo podcast",
  },
  "comedy-style": {
    [Language.ENGLISH]: "Comedy style",
    [Language.SPANISH]: "Estilo comedia",
    [Language.PORTUGUESE]: "Estilo comedia",
  },
  "tutorial-style": {
    [Language.ENGLISH]: "Tutorial style",
    [Language.SPANISH]: "Estilo tutorial",
    [Language.PORTUGUESE]: "Estilo tutorial",
  },
  "testimonial-style": {
    [Language.ENGLISH]: "Testimonial style",
    [Language.SPANISH]: "Estilo testimonial",
    [Language.PORTUGUESE]: "Estilo testimonial",
  },
  "generate-scripts": {
    [Language.ENGLISH]: "Generate scripts",
    [Language.SPANISH]: "Generar guiones",
    [Language.PORTUGUESE]: "Gerar guias",
  },
  "generating-your-scripts": {
    [Language.ENGLISH]: "Generating your scripts",
    [Language.SPANISH]: "Generando tus guiones",
    [Language.PORTUGUESE]: "Gerando seus guias",
  },
  "this-might-take-a-few-moments": {
    [Language.ENGLISH]: "This might take a few moments...",
    [Language.SPANISH]: "Esto puede tomar unos minutos...",
    [Language.PORTUGUESE]: "Isso pode levar alguns momentos...",
  },
  "create-ad": {
    [Language.ENGLISH]: "Create ad",
    [Language.SPANISH]: "Crear anuncio",
    [Language.PORTUGUESE]: "Criar anúncio",
  },
  style: {
    [Language.ENGLISH]: "Style",
    [Language.SPANISH]: "Estilo",
    [Language.PORTUGUESE]: "Estilo",
  },
  "controversial-expert-style": {
    [Language.ENGLISH]: "Controversial expert",
    [Language.SPANISH]: "Experto polémico",
    [Language.PORTUGUESE]: "Experto polêmico",
  },
  "dark-conspiracy-style": {
    [Language.ENGLISH]: "Dark conspiracy",
    [Language.SPANISH]: "Conspiración oscura",
    [Language.PORTUGUESE]: "Conspirância escura",
  },
  "honest-review-style": {
    [Language.ENGLISH]: "Honest review",
    [Language.SPANISH]: "Reseña honesta",
    [Language.PORTUGUESE]: "Resenha honesta",
  },

  // FUNNELS PAGE
  "my-funnels": {
    [Language.ENGLISH]: "My funnels",
    [Language.SPANISH]: "Mis embudos",
    [Language.PORTUGUESE]: "Meus embudos",
  },
  "manage-your-sales-funnels": {
    [Language.ENGLISH]: "Manage your sales funnels",
    [Language.SPANISH]: "Gestiona tus embudos de ventas",
    [Language.PORTUGUESE]: "Gerencia seus embudos de vendas",
  },
  "create-funnel": {
    [Language.ENGLISH]: "Create funnel",
    [Language.SPANISH]: "Crear embudo",
    [Language.PORTUGUESE]: "Criar embudo",
  },
  "create-home": {
    [Language.ENGLISH]: "Create home",
    [Language.SPANISH]: "Crear tienda",
    [Language.PORTUGUESE]: "Criar loja",
  },
  "connected-funnels": {
    [Language.ENGLISH]: "Connected funnels",
    [Language.SPANISH]: "Embudos conectados",
    [Language.PORTUGUESE]: "Embudos conectados",
  },
  "are-you-sure-you-want-to-delete-this-funnel": {
    [Language.ENGLISH]: "Are you sure you want to delete this funnel?",
    [Language.SPANISH]: "¿Estás seguro de querer eliminar este embudo?",
    [Language.PORTUGUESE]: "Tem certeza que deseja deletar este embudo?",
  },
  "this-action-cannot-be-undone": {
    [Language.ENGLISH]: "This action cannot be undone.",
    [Language.SPANISH]: "Esta acción no puede ser deshecha.",
    [Language.PORTUGUESE]: "Esta ação não pode ser desfeita.",
  },
  delete: {
    [Language.ENGLISH]: "Delete",
    [Language.SPANISH]: "Eliminar",
    [Language.PORTUGUESE]: "Deletar",
  },
  active: {
    [Language.ENGLISH]: "Active",
    [Language.SPANISH]: "Activo",
    [Language.PORTUGUESE]: "Ativo",
  },
  draft: {
    [Language.ENGLISH]: "Draft",
    [Language.SPANISH]: "Borrador",
    [Language.PORTUGUESE]: "Rascunho",
  },
  processing: {
    [Language.ENGLISH]: "Processing",
    [Language.SPANISH]: "Procesando",
    [Language.PORTUGUESE]: "Processando",
  },
  "funnel-created": {
    [Language.ENGLISH]: "Funnel created",
    [Language.SPANISH]: "Embudo creado",
    [Language.PORTUGUESE]: "Embudo criado",
  },
  edit: {
    [Language.ENGLISH]: "Edit",
    [Language.SPANISH]: "Editar",
    [Language.PORTUGUESE]: "Editar",
  },
  stats: {
    [Language.ENGLISH]: "Stats",
    [Language.SPANISH]: "Estadísticas",
    [Language.PORTUGUESE]: "Métricas",
  },
  metrics: {
    [Language.ENGLISH]: "Metrics",
    [Language.SPANISH]: "Métricas",
    [Language.PORTUGUESE]: "Métricas",
  },
  "ai-auto-optimization": {
    [Language.ENGLISH]: "AI Auto-Optimization",
    [Language.SPANISH]: "Optimización automática de IA",
    [Language.PORTUGUESE]: "Otimização automática de IA",
  },
  duplicate: {
    [Language.ENGLISH]: "Duplicate",
    [Language.SPANISH]: "Duplicar",
    [Language.PORTUGUESE]: "Duplicar",
  },
  "product-information-incomplete": {
    [Language.ENGLISH]:
      "Please make sure the product has a name, price, description, and images.",
    [Language.SPANISH]:
      "Por favor, asegúrate de que el producto tenga un nombre, precio, descripción y imágenes.",
    [Language.PORTUGUESE]:
      "Por favor, certifique-se de que o produto tenha um nome, preço, descrição e imagens.",
  },
  "product-information-incomplete-title": {
    [Language.ENGLISH]: "Product Information Incomplete",
    [Language.SPANISH]: "Información del producto incompleta",
    [Language.PORTUGUESE]: "Informações do produto incompletas",
  },
  "describe-your-custom-sales-angle": {
    [Language.ENGLISH]: "Describe your custom sales angle",
    [Language.SPANISH]: "Describe tu ángulo de venta personalizado",
    [Language.PORTUGUESE]: "Descreva seu ângulo de venda personalizado",
  },
  "describe-your-custom-sales-angle-placeholder": {
    [Language.ENGLISH]:
      "Describe how you want to position your product to potential customers...",
    [Language.SPANISH]:
      "Describe cómo quieres posicionar tu producto a potenciales clientes...",
    [Language.PORTUGUESE]:
      "Descreva como você deseja posicionar seu produto para potenciais clientes...",
  },
  "describe-your-custom-sales-angle-footer": {
    [Language.ENGLISH]:
      "Be specific about the unique selling proposition and the emotional appeal you want to create.",
    [Language.SPANISH]:
      "Sé específico sobre la propuesta de valor única y el atractivo emocional que quieres crear.",
    [Language.PORTUGUESE]:
      "Seja específico sobre a proposta de valor única e o apelo emocional que você deseja criar.",
  },
  "magic-title-step-3": {
    [Language.ENGLISH]: "Magic happens here!",
    [Language.SPANISH]: "¡Magia sucede aquí!",
    [Language.PORTUGUESE]: "A magia acontece aqui!",
  },
  "magic-description-step-3": {
    [Language.ENGLISH]:
      "Product bundles are key to increasing your average order value and making more money",
    [Language.SPANISH]:
      "Los paquetes de productos son clave para aumentar tu valor promedio de pedido y ganar más dinero",
    [Language.PORTUGUESE]:
      "Os pacotes de produtos são chave para aumentar seu valor médio de pedido e ganhar mais dinheiro",
  },
  "order-bump-description": {
    [Language.ENGLISH]:
      "Add a small complementary item that customers can add with a single click",
    [Language.SPANISH]:
      "Agrega un pequeño artículo complementario que los clientes pueden agregar con un solo clic",
    [Language.PORTUGUESE]:
      "Adicione um pequeno item complementar que os clientes podem adicionar com um único clique",
  },
  "upsell-title": {
    [Language.ENGLISH]: "UpSell",
    [Language.SPANISH]: "Upsell",
    [Language.PORTUGUESE]: "Upsell",
  },
  "upsell-description": {
    [Language.ENGLISH]:
      "Offer complementary products at special prices to increase the value of the purchase",
    [Language.SPANISH]:
      "Oferta productos complementarios a precios especiales para aumentar el valor de la compra",
    [Language.PORTUGUESE]:
      "Ofereça produtos complementares a preços especiais para aumentar o valor da compra",
  },
  "complementary-products": {
    [Language.ENGLISH]: "Complementary products",
    [Language.SPANISH]: "Productos complementarios",
    [Language.PORTUGUESE]: "Produtos complementares",
  },

  // ONBOARDING PAGE
  "magical-funnel-creation": {
    [Language.ENGLISH]: "Magical funnel creation",
    [Language.SPANISH]: "Creación de embudo mágica",
    [Language.PORTUGUESE]: "Criação de funil mágico",
  },
  "product-details": {
    [Language.ENGLISH]: "Product details",
    [Language.SPANISH]: "Detalles del producto",
    [Language.PORTUGUESE]: "Detalhes do produto",
  },
  "marketing-angle": {
    [Language.ENGLISH]: "Marketing angle",
    [Language.SPANISH]: "Ángulo de marketing",
    [Language.PORTUGUESE]: "Ângulo de marketing",
  },
  "upsell-options": {
    [Language.ENGLISH]: "Upsell options",
    [Language.SPANISH]: "Opciones de upsell",
    [Language.PORTUGUESE]: "Opções de upsell",
  },
  "brand-style": {
    [Language.ENGLISH]: "Brand & style",
    [Language.SPANISH]: "Marca y estilo",
    [Language.PORTUGUESE]: "Marca e estilo",
  },
  "select-a-product-for-your-sales-funnel": {
    [Language.ENGLISH]: "Select a product for your sales funnel",
    [Language.SPANISH]: "Selecciona un producto para tu embudo de ventas",
    [Language.PORTUGUESE]: "Selecione um produto para seu funil de vendas",
  },
  "import-from-link": {
    [Language.ENGLISH]: "Import from link",
    [Language.SPANISH]: "Importar desde link",
    [Language.PORTUGUESE]: "Importar desde link",
  },
  "enter-manually": {
    [Language.ENGLISH]: "Enter manually",
    [Language.SPANISH]: "Ingresar manualmente",
    [Language.PORTUGUESE]: "Entrar manualmente",
  },
  "your-products": {
    [Language.ENGLISH]: "Your products",
    [Language.SPANISH]: "Tus productos",
    [Language.PORTUGUESE]: "Seus produtos",
  },
  "choose-different-method": {
    [Language.ENGLISH]: "Choose different method",
    [Language.SPANISH]: "Elegir un método diferente",
    [Language.PORTUGUESE]: "Escolher um método diferente",
  },
  "import-product-from-link": {
    [Language.ENGLISH]: "Import product from link",
    [Language.SPANISH]: "Importar producto desde link",
    [Language.PORTUGUESE]: "Importar produto desde link",
  },
  "searching-your-product": {
    [Language.ENGLISH]: "Searching your product...",
    [Language.SPANISH]: "Buscando tu producto...",
    [Language.PORTUGUESE]: "Buscando seu produto...",
  },
  "paste-product-url-placeholder": {
    [Language.ENGLISH]: "Paste product URL",
    [Language.SPANISH]: "Pega la URL del producto",
    [Language.PORTUGUESE]: "Cole a URL do produto",
  },
  "product-information": {
    [Language.ENGLISH]: "Product information",
    [Language.SPANISH]: "Información del producto",
    [Language.PORTUGUESE]: "Informações do produto",
  },
  "upload-image": {
    [Language.ENGLISH]: "Upload Image",
    [Language.SPANISH]: "Subir Imagen",
    [Language.PORTUGUESE]: "Subir Imagem",
  },
  "upload-images": {
    [Language.ENGLISH]: "Upload Images",
    [Language.SPANISH]: "Subir Imágenes",
    [Language.PORTUGUESE]: "Subir Imagens",
  },
  "accepted-formats": {
    [Language.ENGLISH]: "Accepted formats: JPG, PNG, WEBP and JPEG",
    [Language.SPANISH]: "Formatos aceptados: JPG, PNG, WEBP y JPEG",
    [Language.PORTUGUESE]: "Formatos aceitos: JPG, PNG, WEBP e JPEG",
  },
  "drag-and-drop-your-images-here-or-click-to-select": {
    [Language.ENGLISH]: "Drag and drop your images here or click to select",
    [Language.SPANISH]:
      "Arrastra y suelta tus imágenes aquí o haz clic para seleccionar",
    [Language.PORTUGUESE]:
      "Arraste e solte suas imagens aqui ou clique para selecionar",
  },
  "add-more-images": {
    [Language.ENGLISH]: "Add more images",
    [Language.SPANISH]: "Agregar más imágenes",
    [Language.PORTUGUESE]: "Adicionar mais imagens",
  },
  "product-details-placeholder": {
    [Language.ENGLISH]: "Product details",
    [Language.SPANISH]: "Detalles del producto",
    [Language.PORTUGUESE]: "Detalhes do produto",
  },
  "product-name-placeholder-manual-entry": {
    [Language.ENGLISH]: "Example: Adidas predator",
    [Language.SPANISH]: "Ejemplo: Adidas predator",
    [Language.PORTUGUESE]: "Exemplo: Adidas predator",
  },
  "product-details-placeholder-manual-entry": {
    [Language.ENGLISH]:
      "Describe the main features and benefits of your product...",
    [Language.SPANISH]:
      "Describe las principales características y beneficios de tu producto...",
    [Language.PORTUGUESE]:
      "Descreva as principais características e benefícios de seu produto...",
  },
  "search-previous-products-placeholder": {
    [Language.ENGLISH]: "Search previous products",
    [Language.SPANISH]: "Buscar productos anteriores",
    [Language.PORTUGUESE]: "Buscar produtos anteriores",
  },
  next: {
    [Language.ENGLISH]: "Next",
    [Language.SPANISH]: "Siguiente",
    [Language.PORTUGUESE]: "Próximo",
  },
  previous: {
    [Language.ENGLISH]: "Previous",
    [Language.SPANISH]: "Anterior",
    [Language.PORTUGUESE]: "Anterior",
  },
  "loading-personalized-sales-angles": {
    [Language.ENGLISH]: "Loading personalized sales angles...",
    [Language.SPANISH]: "Cargando ángulos de venta personalizados...",
    [Language.PORTUGUESE]: "Carregando ângulos de venda personalizados...",
  },
  recommended: {
    [Language.ENGLISH]: "Recommended",
    [Language.SPANISH]: "Recomendado",
    [Language.PORTUGUESE]: "Recomendado",
  },
  "choose-1-to-6-sales-angles-for-your-funnels": {
    [Language.ENGLISH]: "Choose 1 to 6 sales angles for your funnels",
    [Language.SPANISH]: "Elige 1 a 6 ángulos de venta para tus embudos",
    [Language.PORTUGUESE]: "Escolha 1 a 6 ângulos de venda para seus embudos",
  },
  "free-shipping": {
    [Language.ENGLISH]: "Free shipping",
    [Language.SPANISH]: "Envío gratis",
    [Language.PORTUGUESE]: "Frete grátis",
  },
  "30-days-warranty": {
    [Language.ENGLISH]: "30 days warranty",
    [Language.SPANISH]: "30 días de garantía",
    [Language.PORTUGUESE]: "30 dias de garantia",
  },
  "90-days-warranty": {
    [Language.ENGLISH]: "90 days warranty",
    [Language.SPANISH]: "90 días de garantía",
    [Language.PORTUGUESE]: "90 dias de garantia",
  },
  "custom-warranty": {
    [Language.ENGLISH]: "Custom warranty",
    [Language.SPANISH]: "Garantía personalizada",
    [Language.PORTUGUESE]: "Garantia personalizada",
  },
  "no-products-found": {
    [Language.ENGLISH]: "No products found",
    [Language.SPANISH]: "No se encontraron productos",
    [Language.PORTUGUESE]: "Nenhum produto encontrado",
  },
  "loading-products": {
    [Language.ENGLISH]: "Loading products...",
    [Language.SPANISH]: "Cargando productos...",
    [Language.PORTUGUESE]: "Carregando produtos...",
  },
  "import-order bump-from-link": {
    [Language.ENGLISH]: "Import order bump from link",
    [Language.SPANISH]: "Importar oferta de aumento desde link",
    [Language.PORTUGUESE]: "Importar oferta de aumento desde link",
  },
  "import-upsell-from-link": {
    [Language.ENGLISH]: "Import upsell from link",
    [Language.SPANISH]: "Importar upsell desde link",
    [Language.PORTUGUESE]: "Importar upsell desde link",
  },
  "product-image-automatically-imported": {
    [Language.ENGLISH]:
      "The product image will be automatically imported from the marketplace.",
    [Language.SPANISH]:
      "La imagen del producto se importará automáticamente desde el marketplace.",
    [Language.PORTUGUESE]:
      "A imagem do produto será importada automaticamente do marketplace.",
  },
  "upload-an-image-of-your-product": {
    [Language.ENGLISH]: "Upload an image of your product",
    [Language.SPANISH]: "Subir una imagen de tu producto",
    [Language.PORTUGUESE]: "Subir uma imagem do seu produto",
  },
  "upload-product-image": {
    [Language.ENGLISH]: "Upload product image",
    [Language.SPANISH]: "Subir imagen del producto",
    [Language.PORTUGUESE]: "Subir imagem do produto",
  },
  description: {
    [Language.ENGLISH]: "Description",
    [Language.SPANISH]: "Descripción",
    [Language.PORTUGUESE]: "Descrição",
  },
  "enter-product-name-placeholder": {
    [Language.ENGLISH]: "Enter product name",
    [Language.SPANISH]: "Ingresar nombre del producto",
    [Language.PORTUGUESE]: "Digite o nome do produto",
  },
  "enter-price-placeholder": {
    [Language.ENGLISH]: "Enter price",
    [Language.SPANISH]: "Ingresar precio",
    [Language.PORTUGUESE]: "Digite o preço",
  },
  "enter-description-placeholder": {
    [Language.ENGLISH]: "Enter description",
    [Language.SPANISH]: "Ingresar descripción",
    [Language.PORTUGUESE]: "Digite a descrição",
  },
  "product-information-incomplete-message": {
    [Language.ENGLISH]:
      "Please make sure the product has a name, price, description, and images.",
    [Language.SPANISH]:
      "Por favor, asegúrate de que el producto tenga un nombre, precio, descripción y imágenes.",
    [Language.PORTUGUESE]:
      "Por favor, certifique-se de que o produto tenha um nome, preço, descrição e imagens.",
  },
  "one-last-thing-tell-us-about-your-brand": {
    [Language.ENGLISH]: "One last thing! Tell us about your brand",
    [Language.SPANISH]: "¡Una última cosa! Cuéntanos sobre tu marca",
    [Language.PORTUGUESE]: "Uma última coisa! Conte-nos sobre sua marca",
  },
  "generating-suggestions-with-ai": {
    [Language.ENGLISH]: "Generating suggestions with AI ...",
    [Language.SPANISH]: "Generando sugerencias con IA ...",
    [Language.PORTUGUESE]: "Gerando sugestões com IA ...",
  },
  generating: {
    [Language.ENGLISH]: "Generating...",
    [Language.SPANISH]: "Generando...",
    [Language.PORTUGUESE]: "Gerando...",
  },
  generate: {
    [Language.ENGLISH]: "Generate",
    [Language.SPANISH]: "Generar",
    [Language.PORTUGUESE]: "Gerar",
  },
  "brand-name": {
    [Language.ENGLISH]: "Brand name",
    [Language.SPANISH]: "Nombre de la marca",
    [Language.PORTUGUESE]: "Nome da marca",
  },
  "enter-your-brand-name-placeholder": {
    [Language.ENGLISH]: "Enter your brand name",
    [Language.SPANISH]: "Ingresar nombre de la marca",
    [Language.PORTUGUESE]: "Digite o nome da marca",
  },
  "price-configuration": {
    [Language.ENGLISH]: "Price configuration (In dollars USA)",
    [Language.SPANISH]: "Configuración de precios (En pesos colombianos)",
    [Language.PORTUGUESE]: "Configuração de preços (Em reais brasileiros)",
  },
  "no-products-configured": {
    [Language.ENGLISH]: "No products configured.",
    [Language.SPANISH]: "No hay productos configurados.",
    [Language.PORTUGUESE]: "Nenhum produto configurado.",
  },
  "product-with-variants-message": {
    [Language.ENGLISH]:
      "This product will be created with variations based on the Dropi page and will be reflected in the created funnel",
    [Language.SPANISH]:
      "Este producto se creará con variaciones basadas en la página de Dropi y quedará reflejado en el embudo creado",
    [Language.PORTUGUESE]:
      "Este produto será criado com variações baseadas na página do Dropi e refletirá no funil criado",
  },
  "main-product": {
    [Language.ENGLISH]: "Main product",
    [Language.SPANISH]: "Producto principal",
    [Language.PORTUGUESE]: "Produto principal",
  },
  "order-bump": {
    [Language.ENGLISH]: "Order bump",
    [Language.SPANISH]: "Order bump",
    [Language.PORTUGUESE]: "Order bump",
  },
  "money-back-guarantee": {
    [Language.ENGLISH]: "Money-Back Guarantee",
    [Language.SPANISH]: "Garantía de devolución de dinero",
    [Language.PORTUGUESE]: "Garantia de devolução de dinheiro",
  },
  days: {
    [Language.ENGLISH]: "Days",
    [Language.SPANISH]: "Días",
    [Language.PORTUGUESE]: "Dias",
  },
  "free-shipfping": {
    [Language.ENGLISH]: "Free shipping",
    [Language.SPANISH]: "Envío gratis",
    [Language.PORTUGUESE]: "Frete grátis",
  },
  "please-select-a-minimum-of-1-marketing-angle": {
    [Language.ENGLISH]: "Please select a minimum of 1 marketing angle.",
    [Language.SPANISH]:
      "Por favor, selecciona un mínimo de 1 ángulo de marketing.",
    [Language.PORTUGUESE]:
      "Por favor, selecione um mínimo de 1 ângulo de marketing.",
  },
  "marketing-angle-required": {
    [Language.ENGLISH]: "Marketing angle required",
    [Language.SPANISH]: "Ángulo de marketing requerido",
    [Language.PORTUGUESE]: "Ângulo de marketing requerido",
  },

  // SETTINGS PAGE
  "payment-methods": {
    [Language.ENGLISH]: "Payment methods",
    [Language.SPANISH]: "Métodos de pago",
    [Language.PORTUGUESE]: "Métodos de pagamento",
  },
  "customer-support": {
    [Language.ENGLISH]: "Customer support",
    [Language.SPANISH]: "Soporte al cliente",
    [Language.PORTUGUESE]: "Suporte ao cliente",
  },
  logout: {
    [Language.ENGLISH]: "Logout",
    [Language.SPANISH]: "Cerrar sesión",
    [Language.PORTUGUESE]: "Sair",
  },
  "payment-methods-description": {
    [Language.ENGLISH]: "Manage your payment methods",
    [Language.SPANISH]: "Gestiona tus métodos de pago",
    [Language.PORTUGUESE]: "Gerencie seus métodos de pagamento",
  },

  // Funnel Statistics
  "funnel-statistics": {
    [Language.ENGLISH]: "Funnel statistics",
    [Language.SPANISH]: "Estadísticas del embudo",
    [Language.PORTUGUESE]: "Estatísticas do funil",
  },
  "total-revenue": {
    [Language.ENGLISH]: "Total Revenue",
    [Language.SPANISH]: "Ingresos totales",
    [Language.PORTUGUESE]: "Receita total",
  },
  "average-ticket": {
    [Language.ENGLISH]: "Average Ticket",
    [Language.SPANISH]: "Ticket promedio",
    [Language.PORTUGUESE]: "Ticket médio",
  },
  "funnel-products": {
    [Language.ENGLISH]: "Funnel Products",
    [Language.SPANISH]: "Productos del embudo",
    [Language.PORTUGUESE]: "Produtos do funil",
  },
  "no-sales-yet": {
    [Language.ENGLISH]: "There are no sales yet",
    [Language.SPANISH]: "No hay ventas aún",
    [Language.PORTUGUESE]: "Ainda não há vendas",
  },
  "total-visits": {
    [Language.ENGLISH]: "Total Visits",
    [Language.SPANISH]: "Visitas totales",
    [Language.PORTUGUESE]: "Visitas totais",
  },
  revenue: {
    [Language.ENGLISH]: "Revenue",
    [Language.SPANISH]: "Ingresos",
    [Language.PORTUGUESE]: "Receita",
  },
  visits: {
    [Language.ENGLISH]: "Visits",
    [Language.SPANISH]: "Visitas",
    [Language.PORTUGUESE]: "Visitas",
  },
  conversion: {
    [Language.ENGLISH]: "Conversion",
    [Language.SPANISH]: "Conversión",
    [Language.PORTUGUESE]: "Conversão",
  },

  // times
  "all-dates": {
    [Language.ENGLISH]: "All Dates",
    [Language.SPANISH]: "Todas las fechas",
    [Language.PORTUGUESE]: "Todas as datas",
  },
  "last-7-days": {
    [Language.ENGLISH]: "Last 7 Days",
    [Language.SPANISH]: "Últimos 7 días",
    [Language.PORTUGUESE]: "Últimos 7 dias",
  },
  "last-30-days": {
    [Language.ENGLISH]: "Last 30 Days",
    [Language.SPANISH]: "Últimos 30 días",
    [Language.PORTUGUESE]: "Últimos 30 dias",
  },
  "last-90-days": {
    [Language.ENGLISH]: "Last 90 Days",
    [Language.SPANISH]: "Últimos 90 días",
    [Language.PORTUGUESE]: "Últimos 90 dias",
  },
  "custom-range": {
    [Language.ENGLISH]: "Custom Range",
    [Language.SPANISH]: "Rango personalizado",
    [Language.PORTUGUESE]: "Intervalo personalizado",
  },

  // buttons
  "change-currency": {
    [Language.ENGLISH]: "Change currency",
    [Language.SPANISH]: "Cambiar moneda",
    [Language.PORTUGUESE]: "Mudar moeda",
  },
  // payment methods
  inactive: {
    [Language.ENGLISH]: "Inactive",
    [Language.SPANISH]: "Inactivo",
    [Language.PORTUGUESE]: "Inativo",
  },
  on: {
    [Language.ENGLISH]: "On",
    [Language.SPANISH]: "Encendido",
    [Language.PORTUGUESE]: "Ligado",
  },
  off: {
    [Language.ENGLISH]: "Off",
    [Language.SPANISH]: "Apagado",
    [Language.PORTUGUESE]: "Desligado",
  },
  update: {
    [Language.ENGLISH]: "Update",
    [Language.SPANISH]: "Actualizar",
    [Language.PORTUGUESE]: "Atualizar",
  },
  connect: {
    [Language.ENGLISH]: "Connect",
    [Language.SPANISH]: "Conectar",
    [Language.PORTUGUESE]: "Conectar",
  },

  // CURRENCY
  "currency-cop": {
    [Language.ENGLISH]: "COP",
    [Language.SPANISH]: "COP",
    [Language.PORTUGUESE]: "COP",
  },
  "currency-usd": {
    [Language.ENGLISH]: "USD",
    [Language.SPANISH]: "USD",
    [Language.PORTUGUESE]: "USD",
  },
  "upsell-offer": {
    [Language.ENGLISH]: "Upsell",
    [Language.SPANISH]: "Upsell",
    [Language.PORTUGUESE]: "Upsell",
  },
  "create-funnels": {
    [Language.ENGLISH]: "Create funnels",
    [Language.SPANISH]: "Crear embudos",
    [Language.PORTUGUESE]: "Criar funis",
  },

  // Funnels Card
  "funnel-creation": {
    [Language.ENGLISH]: "Funnel Creation",
    [Language.SPANISH]: "Creación de embudo",
    [Language.PORTUGUESE]: "Criação de funil",
  },
  "researching-target-audience": {
    [Language.ENGLISH]: "Researching Target Audience",
    [Language.SPANISH]: "Investigación de público objetivo",
    [Language.PORTUGUESE]: "Pesquisa de público alvo",
  },
  "uncovering-unique-insights": {
    [Language.ENGLISH]: "Uncovering Unique Insights",
    [Language.SPANISH]: "Descubriendo insights únicos",
    [Language.PORTUGUESE]: "Descobrindo insights únicos",
  },
  "identifying-pain-points": {
    [Language.ENGLISH]: "Identifying Pain Points",
    [Language.SPANISH]: "Identificando puntos de dolor",
    [Language.PORTUGUESE]: "Identificando pontos de dor",
  },
  "writing-persuasive-copy": {
    [Language.ENGLISH]: "Writing Persuasive Copy",
    [Language.SPANISH]: "Escribiendo copy persuasivo",
    [Language.PORTUGUESE]: "Escrevendo copy persuasivo",
  },
  "creating-high-quality-images": {
    [Language.ENGLISH]: "Creating High-Quality Images",
    [Language.SPANISH]: "Creando imágenes de alta calidad",
    [Language.PORTUGUESE]: "Criando imagens de alta qualidade",
  },
  "optimizing-results": {
    [Language.ENGLISH]: "Optimizing Results",
    [Language.SPANISH]: "Optimizando resultados",
    [Language.PORTUGUESE]: "Otimizando resultados",
  },
  "refining-the-details": {
    [Language.ENGLISH]: "Refining the Details",
    [Language.SPANISH]: "Refinando los detalles",
    [Language.PORTUGUESE]: "Refinando os detalhes",
  },
  "manage-membership": {
    [Language.ENGLISH]: "Manage membership",
    [Language.SPANISH]: "Gestionar membresía",
    [Language.PORTUGUESE]: "Gerenciar membros",
  },
  "go-out": {
    [Language.ENGLISH]: "Log out",
    [Language.SPANISH]: "Salir",
    [Language.PORTUGUESE]: "Sair",
  },
  membership: {
    [Language.ENGLISH]: "Membership",
    [Language.SPANISH]: "Membresia",
    [Language.PORTUGUESE]: "Membros",
  },
  credits: {
    [Language.ENGLISH]: "Credits",
    [Language.SPANISH]: "Créditos",
    [Language.PORTUGUESE]: "Créditos",
  },
  available: {
    [Language.ENGLISH]: "available",
    [Language.SPANISH]: "disponibles",
    [Language.PORTUGUESE]: "disponíveis",
  },
  "credits-usage": {
    [Language.ENGLISH]: "Credits usage",
    [Language.SPANISH]: "Uso de créditos",
    [Language.PORTUGUESE]: "Uso de créditos",
  },
  "credits-used": {
    [Language.ENGLISH]: "Credits used",
    [Language.SPANISH]: "Créditos usados",
    [Language.PORTUGUESE]: "Créditos usados",
  },
  "credits-remaining": {
    [Language.ENGLISH]: "Credits remaining",
    [Language.SPANISH]: "Créditos restantes",
    [Language.PORTUGUESE]: "Créditos restantes",
  },
  "plan-total": {
    [Language.ENGLISH]: "Plan total",
    [Language.SPANISH]: "Total del plan",
    [Language.PORTUGUESE]: "Total do plano",
  },
  "payment-history": {
    [Language.ENGLISH]: "Payment history",
    [Language.SPANISH]: "Historial de pagos",
    [Language.PORTUGUESE]: "Histórico de pagamentos",
  },
  "activation-date": {
    [Language.ENGLISH]: "Activation date",
    [Language.SPANISH]: "Fecha de activación",
    [Language.PORTUGUESE]: "Data de ativação",
  },
  "upcoming-renovation": {
    [Language.ENGLISH]: "Upcoming renewal",
    [Language.SPANISH]: "Próxima renovación",
    [Language.PORTUGUESE]: "Renovação próxima",
  },
  succeeded: {
    [Language.ENGLISH]: "Succeeded",
    [Language.SPANISH]: "Completado",
    [Language.PORTUGUESE]: "Completado",
  },
  failed: {
    [Language.ENGLISH]: "Failed",
    [Language.SPANISH]: "Fallido",
    [Language.PORTUGUESE]: "Falhou",
  },
  "try-again": {
    [Language.ENGLISH]: "Try again",
    [Language.SPANISH]: "Volver a intentar",
    [Language.PORTUGUESE]: "Tentar novamente",
  },
  sorry: {
    [Language.ENGLISH]: "Sorry",
    [Language.SPANISH]: "Lo sentimos",
    [Language.PORTUGUESE]: "Desculpe",
  },
  "error-update-plan": {
    [Language.ENGLISH]: "An error occurred with the update of your plan",
    [Language.SPANISH]: "Ha ocurrido un error con la actualización de tu plan",
    [Language.PORTUGUESE]: "Ocorreu um erro com a atualização do seu plano",
  },
  congratulations: {
    [Language.ENGLISH]: "Congratulations!",
    [Language.SPANISH]: "¡Felicitaciones!",
    [Language.PORTUGUESE]: "Parabéns!",
  },
  "plan-updated": {
    [Language.ENGLISH]: "Your plan has been updated successfully",
    [Language.SPANISH]: "Tu plan ha sido actualizado correctamente",
    [Language.PORTUGUESE]: "Seu plan foi atualizado com sucesso",
  },
  "no-products-found-onboarding": {
    [Language.ENGLISH]: "No products found",
    [Language.SPANISH]: "No se encontraron productos",
    [Language.PORTUGUESE]: "Nenhum produto encontrado",
  },
  "upload-images-description-onboarding-product-manual": {
    [Language.ENGLISH]: "Upload images where your product is clearly visible",
    [Language.SPANISH]: "Sube imágenes donde tu producto se vea claramente",
    [Language.PORTUGUESE]:
      "Carregue imagens onde seu produto seja claramente visível",
  },
  "upload-image-description-onboarding-product-manual": {
    [Language.ENGLISH]:
      "Upload a image where your product is clearly visible, this image will be used to create all the content of your page",
    [Language.SPANISH]:
      "Carga una imagen que muestre de forma clara tu producto, esta imagen se usará para que nuestra inteligencia artificial cree todo el contenido de tu página",
    [Language.PORTUGUESE]:
      "Carregue uma imagem que mostre claramente seu produto, esta imagem será usada para que nossa inteligência artificial crie todo o conteúdo da sua página",
  },
  "upload-images-description-upload-onboarding-product-manual": {
    [Language.ENGLISH]:
      "Upload images that show your product clearly and how it is used, these images will be used to create all the content of your page",
    [Language.SPANISH]:
      "Carga imagenes que muestren de forma clara tu producto y como se utiliza, estas imagenes se usarán para que nuestra inteligencia artificial cree todo el contenido de tu página",
    [Language.PORTUGUESE]:
      "Carregue imagens que mostrem claramente seu produto e como é usado, estas imagens serão usadas para que nossa inteligência artificial crie todo o conteúdo da sua página",
  },
  "order-bump-information-incomplete": {
    [Language.ENGLISH]:
      "Please make sure the order bump has a name, description, and image.",
    [Language.SPANISH]:
      "Por favor, asegúrate de que el order bump tenga un nombre, descripción y imagen.",
    [Language.PORTUGUESE]:
      "Por favor, certifique-se de que o order bump tenha um nome, descrição e imagem.",
  },
  "order-bump-information-incomplete-title": {
    [Language.ENGLISH]: "Order Bump Information Incomplete",
    [Language.SPANISH]: "Información de order bump incompleta",
    [Language.PORTUGUESE]: "Informações do order bump incompleto",
  },
  "upsell-information-incomplete": {
    [Language.ENGLISH]:
      "Please make sure the upsell has a name, description, and image.",
    [Language.SPANISH]:
      "Por favor, asegúrate de que el upsell tenga un nombre, descripción y imagen.",
    [Language.PORTUGUESE]:
      "Por favor, certifique-se de que o upsell tenha um nome, descrição e imagem.",
  },
  "upsell-information-incomplete-title": {
    [Language.ENGLISH]: "Upsell Information Incomplete",
    [Language.SPANISH]: "Información de upsell incompleta",
    [Language.PORTUGUESE]: "Informações do upsell incompleto",
  },
  BUMP_OFFER: {
    [Language.ENGLISH]: "Order Bump",
    [Language.SPANISH]: "Order Bump",
    [Language.PORTUGUESE]: "Order Bump",
  },
  PRINCIPAL: {
    [Language.ENGLISH]: "Main Product",
    [Language.SPANISH]: "Producto principal",
    [Language.PORTUGUESE]: "Produto principal",
  },
  UNKNOWN: {
    [Language.ENGLISH]: "Unknown",
    [Language.SPANISH]: "Desconocido",
    [Language.PORTUGUESE]: "Desconhecido",
  },
  UP_SELL: {
    [Language.ENGLISH]: "Upsell",
    [Language.SPANISH]: "Upsell",
    [Language.PORTUGUESE]: "Upsell",
  },
  integrations: {
    [Language.ENGLISH]: "Integrations",
    [Language.SPANISH]: "Integraciones",
    [Language.PORTUGUESE]: "Integrações",
  },
  cancel: {
    [Language.ENGLISH]: "Cancel",
    [Language.SPANISH]: "Cancelar",
    [Language.PORTUGUESE]: "Cancelar",
  },
  "integration-added": {
    [Language.ENGLISH]: "Integration added",
    [Language.SPANISH]: "Integración agregada",
    [Language.PORTUGUESE]: "Integração adicionada",
  },
  "integration-error": {
    [Language.ENGLISH]: "Integration error",
    [Language.SPANISH]: "Error de integración",
    [Language.PORTUGUESE]: "Erro de integração",
  },
  "integration-canceled": {
    [Language.ENGLISH]: "Integration canceled",
    [Language.SPANISH]: "Integración cancelada",
    [Language.PORTUGUESE]: "Integração cancelada",
  },
  DROPI_TOKEN_INVALID: {
    [Language.ENGLISH]: "Dropi token invalid",
    [Language.SPANISH]: "Token de Dropi inválido",
    [Language.PORTUGUESE]: "Token de Dropi inválido",
  },
  "product-cloned-successfully": {
    [Language.ENGLISH]: "Product cloned successfully",
    [Language.SPANISH]: "Producto duplicado correctamente",
    [Language.PORTUGUESE]: "Produto duplicado com sucesso",
  },
  invalid_token: {
    [Language.ENGLISH]: "Invalid MercadoPago access token",
    [Language.SPANISH]: "Token de acceso de MercadoPago inválido",
    [Language.PORTUGUESE]: "Token de acesso de MercadoPago inválido",
  },
  funnel: {
    [Language.ENGLISH]: "Funnel",
    [Language.SPANISH]: "Embudo",
    [Language.PORTUGUESE]: "Funil",
  },
  created: {
    [Language.ENGLISH]: "Created",
    [Language.SPANISH]: "Creado",
    [Language.PORTUGUESE]: "Criado",
  },
  "integration-dropi": {
    [Language.ENGLISH]: "Integration Dropi",
    [Language.SPANISH]: "Integración Dropi",
    [Language.PORTUGUESE]: "Integração Dropi",
  },
  "integration-dropi-description-success": {
    [Language.ENGLISH]: "Order synchronized correctly",
    [Language.SPANISH]: "Orden sincronizada correctamente",
    [Language.PORTUGUESE]: "Ordem sincronizada corretamente",
  },
  "integration-dropi-description-error": {
    [Language.ENGLISH]: "Order synchronization failed",
    [Language.SPANISH]: "Fallo en la sincronización, orden NO sincronizada",
    [Language.PORTUGUESE]: "Falha na sincronização, ordem não sincronizada",
  },
  "integration-dropi-button-text": {
    [Language.ENGLISH]: "View order in Dropi",
    [Language.SPANISH]: "Ver orden en Dropi",
    [Language.PORTUGUESE]: "Ver ordem em Dropi",
  },
  "funnels-label": {
    [Language.ENGLISH]: "Funnels",
    [Language.SPANISH]: "Embudos",
    [Language.PORTUGUESE]: "Funs",
  },
  "homes-label": {
    [Language.ENGLISH]: "Homes",
    [Language.SPANISH]: "Tiendas",
    [Language.PORTUGUESE]: "Lojas",
  },
  "error-select-funnel": {
    [Language.ENGLISH]: "Please select at least one funnel",
    [Language.SPANISH]: "Por favor, selecciona al menos un embudo",
    [Language.PORTUGUESE]: "Por favor, selecione pelo menos um funil",
  },
  "success-create-home": {
    [Language.ENGLISH]: "Home created successfully",
    [Language.SPANISH]: "Tienda creada correctamente",
    [Language.PORTUGUESE]: "Loja criada com sucesso",
  },
  "error-create-home": {
    [Language.ENGLISH]: "An error occurred with the creation of your home",
    [Language.SPANISH]: "Ha ocurrido un error con la creación de tu tienda",
    [Language.PORTUGUESE]: "Ocorreu um erro com a criação da sua loja",
  },
  "error-brand-data": {
    [Language.ENGLISH]: "Please fill brand name and context",
    [Language.SPANISH]:
      "Por favor, completa el nombre de la marca y el contexto",
    [Language.PORTUGUESE]: "Por favor, complete o nome da marca e o contexto",
  },
  "products-page-description": {
    [Language.ENGLISH]: "Manage all your products",
    [Language.SPANISH]: "Gestiona todos los productos de tu cuenta",
    [Language.PORTUGUESE]: "Gerencie todos os produtos da sua conta",
  },
  "cancel-changes": {
    [Language.ENGLISH]: "Cancel changes",
    [Language.SPANISH]: "Cancelar cambios",
    [Language.PORTUGUESE]: "Cancelar alterações",
  },
  "error-updating-products": {
    [Language.ENGLISH]: "Error updating products. Please try again.",
    [Language.SPANISH]:
      "Error al actualizar los productos. Por favor, intenta nuevamente.",
    [Language.PORTUGUESE]:
      "Erro ao atualizar os produtos. Por favor, tente novamente.",
  },
  "products-updated-successfully": {
    [Language.ENGLISH]: "products updated successfully",
    [Language.SPANISH]: "productos actualizados correctamente",
    [Language.PORTUGUESE]: "produtos atualizados com sucesso",
  },
  "create-new-home": {
    [Language.ENGLISH]: "Create new home",
    [Language.SPANISH]: "Crear nueva tienda",
    [Language.PORTUGUESE]: "Criar nova loja",
  },
  "each-angle-selected-1-credit": {
    [Language.ENGLISH]: "Each angle selected = 1 credit",
    [Language.SPANISH]: "Cada ángulo seleccionado = 1 crédito",
    [Language.PORTUGUESE]: "Cada ângulo selecionado = 1 crédito",
  },
  "1-credit": {
    [Language.ENGLISH]: "1 credit",
    [Language.SPANISH]: "1 crédito",
    [Language.PORTUGUESE]: "1 crédito",
  },
  "generating-video": {
    [Language.ENGLISH]: "Generating video...",
    [Language.SPANISH]: "Generando video...",
    [Language.PORTUGUESE]: "Gerando vídeo...",
  },
  "error-ad-creation": {
    [Language.ENGLISH]: "An error occurred with the creation of the ad",
    [Language.SPANISH]: "Ha ocurrido un error con la creación de la publicidad",
    [Language.PORTUGUESE]: "Ocorreu um erro com a criação da publicidade",
  },
  "no-video-found": {
    [Language.ENGLISH]: "No video found",
    [Language.SPANISH]: "No se encontró video",
    [Language.PORTUGUESE]: "Nenhum vídeo encontrado",
  },
  INITIALIZING: {
    [Language.ENGLISH]: "Pending",
    [Language.SPANISH]: "Pendiente",
    [Language.PORTUGUESE]: "Pendente",
  },
  IN_PROGRESS: {
    [Language.ENGLISH]: "In progress",
    [Language.SPANISH]: "En progreso",
    [Language.PORTUGUESE]: "Em progresso",
  },
  FINISHED: {
    [Language.ENGLISH]: "Done",
    [Language.SPANISH]: "Completado",
    [Language.PORTUGUESE]: "Completado",
  },
  ERROR: {
    [Language.ENGLISH]: "Failed",
    [Language.SPANISH]: "Fallido",
    [Language.PORTUGUESE]: "Falhou",
  },
  "link-copied": {
    [Language.ENGLISH]: "Link copied",
    [Language.SPANISH]: "Link copiado",
    [Language.PORTUGUESE]: "Link copiado",
  },
  "change-plan": {
    [Language.ENGLISH]: "Change plan",
    [Language.SPANISH]: "Cambiar plan",
    [Language.PORTUGUESE]: "Alterar plano",
  },
  "product-images": {
    [Language.ENGLISH]: "Product images",
    [Language.SPANISH]: "Imágenes del producto",
    [Language.PORTUGUESE]: "Imagens do produto",
  },
  "remove-image": {
    [Language.ENGLISH]: "Remove image",
    [Language.SPANISH]: "Eliminar imagen",
    [Language.PORTUGUESE]: "Remover imagem",
  },
  "max-images-reached": {
    [Language.ENGLISH]: "Max images reached",
    [Language.SPANISH]: "Límite alcanzado",
    [Language.PORTUGUESE]: "Limite alcançado",
  },
  "max-file-size-per-image": {
    [Language.ENGLISH]: "Max file size per image is 1MB",
    [Language.SPANISH]: "El límite de tamaño por imagen es de 1MB",
    [Language.PORTUGUESE]: "O limite de tamanho por imagem é de 1MB",
  },
  "uploading-images": {
    [Language.ENGLISH]: "Uploading images...",
    [Language.SPANISH]: "Subiendo imágenes...",
    [Language.PORTUGUESE]: "Carregando imagens...",
  },
  progress: {
    [Language.ENGLISH]: "Progress",
    [Language.SPANISH]: "Progreso",
    [Language.PORTUGUESE]: "Progresso",
  },
  "uploading-image": {
    [Language.ENGLISH]: "Uploading image...",
    [Language.SPANISH]: "Subiendo imagen...",
    [Language.PORTUGUESE]: "Carregando imagem...",
  },
  male: {
    [Language.ENGLISH]: "Male",
    [Language.SPANISH]: "Masculino",
    [Language.PORTUGUESE]: "Masculino",
  },
  female: {
    [Language.ENGLISH]: "Female",
    [Language.SPANISH]: "Femenino",
    [Language.PORTUGUESE]: "Feminino",
  },
  "order-deleted": {
    [Language.ENGLISH]: "Order deleted",
    [Language.SPANISH]: "Orden eliminada",
    [Language.PORTUGUESE]: "Ordem deletada",
  },
  "error-deleting-order": {
    [Language.ENGLISH]: "Error deleting order",
    [Language.SPANISH]: "Error al eliminar la orden",
    [Language.PORTUGUESE]: "Erro ao deletar a ordem",
  },
  "are-you-sure-you-want-to-delete-this-order": {
    [Language.ENGLISH]: "Are you sure you want to delete this order?",
    [Language.SPANISH]: "¿Estás seguro de que deseas eliminar esta orden?",
    [Language.PORTUGUESE]: "Tem certeza que deseja deletar esta ordem?",
  },
  "this-order-is-integrated-with-dropi": {
    [Language.ENGLISH]:
      "This order is integrated with Dropi. If you delete it in Fluxi, you must delete it manually in Dropi to avoid differences between systems.",
    [Language.SPANISH]:
      "Esta orden está integrada con Dropi. Si la eliminas en Fluxi, deberás eliminarla también manualmente en Dropi para evitar diferencias entre sistemas.",
    [Language.PORTUGUESE]:
      "Esta ordem está integrada com Dropi. Se você deletar em Fluxi, deve deletar manualmente em Dropi para evitar diferenças entre sistemas.",
  },
  "this-order-is-integrated-with-shopify": {
    [Language.ENGLISH]:
      "This order is integrated with Shopify. If you delete it in Fluxi, you must delete it manually in Shopify to avoid differences between systems.",
    [Language.SPANISH]:
      "Esta orden está integrada con Shopify. Si la eliminas en Fluxi, deberás eliminarla también manualmente en Shopify para evitar diferencias entre sistemas.",
    [Language.PORTUGUESE]:
      "Esta ordem está integrada com Shopify. Se você deletar em Fluxi, deve deletar manualmente em Shopify para evitar diferenças entre sistemas.",
  },
  "this-order-is-integrated-with-dropi-and-shopify": {
    [Language.ENGLISH]:
      "This order is integrated with Dropi and Shopify. If you delete it in Fluxi, you must delete it manually in both systems to avoid differences.",
    [Language.SPANISH]:
      "Esta orden está integrada con Dropi y Shopify. Si la eliminas en Fluxi, deberás eliminarla también manualmente en ambos sistemas para evitar diferencias.",
    [Language.PORTUGUESE]:
      "Esta ordem está integrada com Dropi e Shopify. Se você deletar em Fluxi, deve deletar manualmente em ambos sistemas para evitar diferenças.",
  },
  "error-getting-order-details": {
    [Language.ENGLISH]: "Error getting order details",
    [Language.SPANISH]: "Error al obtener los detalles de la orden",
    [Language.PORTUGUESE]: "Erro ao obter os detalhes da ordem",
  },
  "custom-angle": {
    [Language.ENGLISH]: "Custom Angle",
    [Language.SPANISH]: "Ángulo personalizado",
    [Language.PORTUGUESE]: "Ângulo personalizado",
  },
  "create-your-own-approach": {
    [Language.ENGLISH]: "Create your own approach.",
    [Language.SPANISH]: "Crea tu propio enfoque.",
    [Language.PORTUGUESE]: "Crie seu próprio enfoque.",
  },
  "visits-unique": {
    [Language.ENGLISH]: "Unique visits",
    [Language.SPANISH]: "Visitas únicas",
    [Language.PORTUGUESE]: "Visitas únicas",
  },
  "login-with-google": {
    [Language.ENGLISH]: "Login with Google",
    [Language.SPANISH]: "Iniciar sesión con Google",
    [Language.PORTUGUESE]: "Iniciar sessão com Google",
  },
  loading: {
    [Language.ENGLISH]: "Loading...",
    [Language.SPANISH]: "Cargando...",
    [Language.PORTUGUESE]: "Carregando...",
  },
  "or-sign-in-with": {
    [Language.ENGLISH]: "Or sign in with",
    [Language.SPANISH]: "O iniciar sesión con",
    [Language.PORTUGUESE]: "O iniciar sessão com",
  },
  "additional-information": {
    [Language.ENGLISH]: "Additional information",
    [Language.SPANISH]: "Información adicional",
    [Language.PORTUGUESE]: "Informação adicional",
  },
  "integration-shopify": {
    [Language.ENGLISH]: "Integration Shopify",
    [Language.SPANISH]: "Integración Shopify",
    [Language.PORTUGUESE]: "Integração Shopify",
  },
  "integration-shopify-description-success": {
    [Language.ENGLISH]: "Order synchronized correctly",
    [Language.SPANISH]: "Orden sincronizada correctamente",
    [Language.PORTUGUESE]: "Ordem sincronizada corretamente",
  },
  "integration-shopify-description-error": {
    [Language.ENGLISH]: "Order synchronization failed",
    [Language.SPANISH]: "Fallo en la sincronización, orden NO sincronizada",
    [Language.PORTUGUESE]: "Falha na sincronização, ordem não sincronizada",
  },
  "buy-credits": {
    [Language.ENGLISH]: "Buy credits",
    [Language.SPANISH]: "Comprar créditos",
    [Language.PORTUGUESE]: "Comprar créditos",
  },
  "remember-use-credits": {
    [Language.ENGLISH]: "Remember to use your credits.",
    [Language.SPANISH]: "Recuerda usar tus créditos.",
    [Language.PORTUGUESE]: "Lembre-se de usar seus créditos.",
  },
  "product-not-found": {
    [Language.ENGLISH]:
      "Product not found, please try again with a different product or enter manually",
    [Language.SPANISH]:
      "No pudimos extraer la información del producto con el link suministrado, por favor intenta con un link diferente o ingresa la infomación manualmente",
    [Language.PORTUGUESE]:
      "Não conseguimos extrair a informação do produto com o link fornecido, por favor tente com um link diferente ou insira a informação manualmente",
  },
  "no-images-found": {
    [Language.ENGLISH]: "No images found",
    [Language.SPANISH]: "No se encontraron imágenes",
    [Language.PORTUGUESE]: "Nenhuma imagem encontrada",
  },
  "product-not-found-title": {
    [Language.ENGLISH]: "Product not found",
    [Language.SPANISH]: "Producto no encontrado",
    [Language.PORTUGUESE]: "Produto não encontrado",
  },
  "no-images-found-title": {
    [Language.ENGLISH]: "No images found",
    [Language.SPANISH]: "No se encontraron imágenes",
    [Language.PORTUGUESE]: "Nenhuma imagem encontrada",
  },
  english: {
    [Language.ENGLISH]: "English",
    [Language.SPANISH]: "Ingles",
    [Language.PORTUGUESE]: "Inglês",
  },
  spanish: {
    [Language.ENGLISH]: "Spanish",
    [Language.SPANISH]: "Español",
    [Language.PORTUGUESE]: "Espanhol",
  },
  portuguese: {
    [Language.ENGLISH]: "Portuguese",
    [Language.SPANISH]: "Portugués",
    [Language.PORTUGUESE]: "Português",
  },
  "what-country-do-you-want-to": {
    [Language.ENGLISH]: "What country do you want to",
    [Language.SPANISH]: "¿En qué país quieres",
    [Language.PORTUGUESE]: "Em que país você quer",
  },
  "sell-with-fluxi": {
    [Language.ENGLISH]: "sell with Fluxi?",
    [Language.SPANISH]: "vender con Fluxi?",
    [Language.PORTUGUESE]: "vender com Fluxi?",
  },
  "welcome-to": {
    [Language.ENGLISH]: "Welcome to",
    [Language.SPANISH]: "Bienvenid@ a",
    [Language.PORTUGUESE]: "Bem-vindo(a) ao",
  },
  fluxi: {
    [Language.ENGLISH]: "Fluxi",
    [Language.SPANISH]: "Fluxi",
    [Language.PORTUGUESE]: "Fluxi",
  },
  "configure-your-account-in-a-few-moments": {
    [Language.ENGLISH]: "Configure your account in a few moments",
    [Language.SPANISH]: "Configura tu cuenta en solo unos momentos",
    [Language.PORTUGUESE]: "Configure sua conta em alguns momentos",
  },
  "select-your-country": {
    [Language.ENGLISH]: "Select your country...",
    [Language.SPANISH]: "Selecciona tu país...",
    [Language.PORTUGUESE]: "Selecione seu país...",
  },
  argentina: {
    [Language.ENGLISH]: "Argentina",
    [Language.SPANISH]: "Argentina",
    [Language.PORTUGUESE]: "Argentina",
  },
  bolivia: {
    [Language.ENGLISH]: "Bolivia",
    [Language.SPANISH]: "Bolivia",
    [Language.PORTUGUESE]: "Bolivia",
  },
  brazil: {
    [Language.ENGLISH]: "Brazil",
    [Language.SPANISH]: "Brasil",
    [Language.PORTUGUESE]: "Brasil",
  },
  chile: {
    [Language.ENGLISH]: "Chile",
    [Language.SPANISH]: "Chile",
    [Language.PORTUGUESE]: "Chile",
  },
  colombia: {
    [Language.ENGLISH]: "Colombia",
    [Language.SPANISH]: "Colombia",
    [Language.PORTUGUESE]: "Colombia",
  },
  "costa-rica": {
    [Language.ENGLISH]: "Costa Rica",
    [Language.SPANISH]: "Costa Rica",
    [Language.PORTUGUESE]: "Costa Rica",
  },
  cuba: {
    [Language.ENGLISH]: "Cuba",
    [Language.SPANISH]: "Cuba",
    [Language.PORTUGUESE]: "Cuba",
  },
  "dominican-republic": {
    [Language.ENGLISH]: "Dominican Republic",
    [Language.SPANISH]: "República Dominicana",
    [Language.PORTUGUESE]: "República Dominicana",
  },
  ecuador: {
    [Language.ENGLISH]: "Ecuador",
    [Language.SPANISH]: "Ecuador",
    [Language.PORTUGUESE]: "Ecuador",
  },
  "el-salvador": {
    [Language.ENGLISH]: "El Salvador",
    [Language.SPANISH]: "El Salvador",
    [Language.PORTUGUESE]: "El Salvador",
  },
  guatemala: {
    [Language.ENGLISH]: "Guatemala",
    [Language.SPANISH]: "Guatemala",
    [Language.PORTUGUESE]: "Guatemala",
  },
  honduras: {
    [Language.ENGLISH]: "Honduras",
    [Language.SPANISH]: "Honduras",
    [Language.PORTUGUESE]: "Honduras",
  },
  mexico: {
    [Language.ENGLISH]: "Mexico",
    [Language.SPANISH]: "México",
    [Language.PORTUGUESE]: "México",
  },
  nicaragua: {
    [Language.ENGLISH]: "Nicaragua",
    [Language.SPANISH]: "Nicaragua",
    [Language.PORTUGUESE]: "Nicaragua",
  },
  panama: {
    [Language.ENGLISH]: "Panama",
    [Language.SPANISH]: "Panamá",
    [Language.PORTUGUESE]: "Panamá",
  },
  paraguay: {
    [Language.ENGLISH]: "Paraguay",
    [Language.SPANISH]: "Paraguay",
    [Language.PORTUGUESE]: "Paraguay",
  },
  peru: {
    [Language.ENGLISH]: "Peru",
    [Language.SPANISH]: "Perú",
    [Language.PORTUGUESE]: "Perú",
  },
  "puerto-rico": {
    [Language.ENGLISH]: "Puerto Rico",
    [Language.SPANISH]: "Puerto Rico",
    [Language.PORTUGUESE]: "Puerto Rico",
  },
  spain: {
    [Language.ENGLISH]: "Spain",
    [Language.SPANISH]: "España",
    [Language.PORTUGUESE]: "Espanha",
  },
  "united-states": {
    [Language.ENGLISH]: "United States",
    [Language.SPANISH]: "Estados Unidos",
    [Language.PORTUGUESE]: "Estados Unidos",
  },
  uruguay: {
    [Language.ENGLISH]: "Uruguay",
    [Language.SPANISH]: "Uruguay",
    [Language.PORTUGUESE]: "Uruguai",
  },
  venezuela: {
    [Language.ENGLISH]: "Venezuela",
    [Language.SPANISH]: "Venezuela",
    [Language.PORTUGUESE]: "Venezuela",
  },
  "the-currency-is-linked-to-your-country": {
    [Language.ENGLISH]: "The currency is linked to your country",
    [Language.SPANISH]: "La moneda está vinculada a tu país",
    [Language.PORTUGUESE]: "A moeda está vinculada ao seu país",
  },
  "you-can-change-the-language-if-you-need": {
    [Language.ENGLISH]: "You can change the language if you need",
    [Language.SPANISH]: "Puedes cambiar el idioma si lo necesitas",
    [Language.PORTUGUESE]: "Você pode mudar o idioma se precisar",
  },
  "complete-configuration": {
    [Language.ENGLISH]: "Complete configuration",
    [Language.SPANISH]: "Completar configuración",
    [Language.PORTUGUESE]: "Completar configuração",
  },
  "these-settings-cannot-be-changed-later": {
    [Language.ENGLISH]: "These settings cannot be changed later",
    [Language.SPANISH]: "Estas configuraciones no se podrán cambiar después",
    [Language.PORTUGUESE]:
      "Estas configurações não podem ser alteradas mais tarde",
  },
  currency: {
    [Language.ENGLISH]: "Currency",
    [Language.SPANISH]: "Moneda",
    [Language.PORTUGUESE]: "Moeda",
  },
  "linked-to-the-country": {
    [Language.ENGLISH]: "Linked to the country",
    [Language.SPANISH]: "Vinculada al país",
    [Language.PORTUGUESE]: "Vinculada ao país",
  },
  language: {
    [Language.ENGLISH]: "Language",
    [Language.SPANISH]: "Idioma",
    [Language.PORTUGUESE]: "Idioma",
  },
  "colombian-peso": {
    [Language.ENGLISH]: "Colombian Peso",
    [Language.SPANISH]: "Peso Colombiano",
    [Language.PORTUGUESE]: "Peso Colombiano",
  },
  dollar: {
    [Language.ENGLISH]: "Dollar",
    [Language.SPANISH]: "Dólar",
    [Language.PORTUGUESE]: "Dólar",
  },
  "local-currency": {
    [Language.ENGLISH]: "Local Currency",
    [Language.SPANISH]: "Moneda local",
    [Language.PORTUGUESE]: "Moeda local",
  },
  "what-country-do-you-want-to-sell-with-fluxi": {
    [Language.ENGLISH]: "What country do you want to sell with Fluxi?",
    [Language.SPANISH]: "¿En qué país quieres vender con Fluxi?",
    [Language.PORTUGUESE]: "Em que país você quer vender com Fluxi?",
  },
  "configuration-completed-successfully": {
    [Language.ENGLISH]: "Configuration completed successfully",
    [Language.SPANISH]: "Configuración completada correctamente",
    [Language.PORTUGUESE]: "Configuração completada com sucesso",
  },
  "error-completing-configuration": {
    [Language.ENGLISH]: "Error completing configuration",
    [Language.SPANISH]: "Error al completar la configuración",
    [Language.PORTUGUESE]: "Erro ao completar a configuração",
  },
  "delete-order": {
    [Language.ENGLISH]: "Delete order",
    [Language.SPANISH]: "Eliminar orden",
    [Language.PORTUGUESE]: "Deletar pedido",
  },
  "filter-by-product": {
    [Language.ENGLISH]: "Filter by product",
    [Language.SPANISH]: "Filtrar por producto",
    [Language.PORTUGUESE]: "Filtrar por produto",
  },
  "filter-by-sale-angle": {
    [Language.ENGLISH]: "Filter by sale angle",
    [Language.SPANISH]: "Filtrar por ángulo de venta",
    [Language.PORTUGUESE]: "Filtrar por ângulo de venda",
  },
  "public-token": {
    [Language.ENGLISH]: "Public token",
    [Language.SPANISH]: "Token público",
    [Language.PORTUGUESE]: "Token público",
  },
  "private-token": {
    [Language.ENGLISH]: "Private token",
    [Language.SPANISH]: "Token privado",
    [Language.PORTUGUESE]: "Token privado",
  },
  "enter-your-public-token": {
    [Language.ENGLISH]: "Enter your public token",
    [Language.SPANISH]: "Ingresa tu token público",
    [Language.PORTUGUESE]: "Insira seu token público",
  },
  "enter-your-private-token": {
    [Language.ENGLISH]: "Enter your private token",
    [Language.SPANISH]: "Ingresa tu token privado",
    [Language.PORTUGUESE]: "Insira seu token privado",
  },
  "add-integration-token": {
    [Language.ENGLISH]: "Add integration token",
    [Language.SPANISH]: "Agregar token de integración",
    [Language.PORTUGUESE]: "Adicionar token de integração",
  },
  "dropi-token": {
    [Language.ENGLISH]: "Dropi token",
    [Language.SPANISH]: "Token de Dropi",
    [Language.PORTUGUESE]: "Token de Dropi",
  },
  save: {
    [Language.ENGLISH]: "Save",
    [Language.SPANISH]: "Guardar",
    [Language.PORTUGUESE]: "Salvar",
  },
  "example-dropi-token": {
    [Language.ENGLISH]: "Ex: sk_live_1234abc...",
    [Language.SPANISH]: "Ej: sk_live_1234abc...",
    [Language.PORTUGUESE]: "Ej: sk_live_1234abc...",
  },
  questions: {
    [Language.ENGLISH]: "Questions?",
    [Language.SPANISH]: "¿Preguntas?",
    [Language.PORTUGUESE]: "Perguntas?",
  },
  "select-credits": {
    [Language.ENGLISH]: "Select the number of credits you want to buy",
    [Language.SPANISH]: "Selecciona la cantidad de créditos que deseas comprar",
    [Language.PORTUGUESE]:
      "Selecione a quantidade de créditos que deseja comprar",
  },
  "credits-quantity": {
    [Language.ENGLISH]: "Credits quantity",
    [Language.SPANISH]: "Cantidad de créditos",
    [Language.PORTUGUESE]: "Quantidade de créditos",
  },
  "error-creating-purchase-link": {
    [Language.ENGLISH]: "Error creating purchase link",
    [Language.SPANISH]: "Error al crear el enlace de compra",
    [Language.PORTUGUESE]: "Erro ao criar o link de compra",
  },
  "pay-now": {
    [Language.ENGLISH]: "Pay now",
    [Language.SPANISH]: "Pagar ahora",
    [Language.PORTUGUESE]: "Pagar agora",
  },
  "payment-successful": {
    [Language.ENGLISH]: "Payment successful",
    [Language.SPANISH]: "Pago exitoso",
    [Language.PORTUGUESE]: "Pagamento realizado com sucesso",
  },
  "payment-failed": {
    [Language.ENGLISH]: "Payment failed",
    [Language.SPANISH]: "Pago fallido",
    [Language.PORTUGUESE]: "Pagamento falhou",
  },
  "purchase-cancelled": {
    [Language.ENGLISH]: "Purchase cancelled",
    [Language.SPANISH]: "Compra cancelada",
    [Language.PORTUGUESE]: "Compra cancelada",
  },
  "purchase-cancelled-description": {
    [Language.ENGLISH]:
      "The purchase could not be completed. No charges were made.",
    [Language.SPANISH]:
      "No se pudo completar la compra. No se ha realizado ningún cargo.",
    [Language.PORTUGUESE]:
      "A compra não pôde ser concluída. Nenhum cargo foi realizado.",
  },
  "payment-failed-description": {
    [Language.ENGLISH]: "We're sorry, we had problems with your card",
    [Language.SPANISH]:
      "Lamentamos lo ocurrido, hemos tenido problemas con tu tarjeta",
    [Language.PORTUGUESE]:
      "Lamentamos o ocorrido, tivemos problemas com sua cartão",
  },
  "payment-successful-description": {
    [Language.ENGLISH]:
      "Great! You have subscribed to [Plan name], you can now enjoy all its benefits",
    [Language.SPANISH]:
      "¡Genial! Te has suscrito al [Nombre del Plan], ya puedes disfrutar de todos sus beneficios",
    [Language.PORTUGUESE]:
      "Ótimo! Você se inscreveu no [Nome do Plano], agora você pode aproveitar todos os seus benefícios",
  },
  "credits-purchased-description": {
    [Language.ENGLISH]:
      "¡Genial! Has adquirido [Cantidad] créditos, ya puedes disfrutar de tus nuevos créditos, recuerda usarlos antes de [fecha de vencimiento] para no dejarlos vencer.",
    [Language.SPANISH]:
      "¡Genial! Has adquirido [Cantidad] créditos, ya puedes disfrutar de tus nuevos créditos, recuerda usarlos antes de [fecha de vencimiento] para no dejarlos vencer.",
    [Language.PORTUGUESE]:
      "Ótimo! Você adquiriu [Quantidade] créditos, agora você pode aproveitar seus novos créditos, lembre-se de usarlos antes de [data de vencimento] para não deixá-los vencer.",
  },
  continue: {
    [Language.ENGLISH]: "Continue",
    [Language.SPANISH]: "Continuar",
    [Language.PORTUGUESE]: "Continuar",
  },
  retry: {
    [Language.ENGLISH]: "Retry",
    [Language.SPANISH]: "Volver a intentar",
    [Language.PORTUGUESE]: "Tentar novamente",
  },
  "credits-purchased": {
    [Language.ENGLISH]: "Credits purchased",
    [Language.SPANISH]: "Créditos comprados",
    [Language.PORTUGUESE]: "Créditos comprados",
  },
  // PAYMENT RESULT PAGE
  "subscription-success-description": {
    [Language.ENGLISH]:
      "Great! You have subscribed to [plan_name], you can now enjoy all its benefits",
    [Language.SPANISH]:
      "¡Genial! Te has suscrito al [plan_name], ya puedes disfrutar de todos sus beneficios",
    [Language.PORTUGUESE]:
      "Ótimo! Você se inscreveu no [plan_name], agora pode aproveitar todos os benefícios",
  },
  "credits-purchased-title": {
    [Language.ENGLISH]: "Credits purchased!",
    [Language.SPANISH]: "¡Créditos comprados!",
    [Language.PORTUGUESE]: "Créditos comprados!",
  },
  "credits-success-description": {
    [Language.ENGLISH]:
      "Great! You have acquired [credits_amount] credits, you can now enjoy your new credits, remember to use them before [expiration_date] so they don't expire.",
    [Language.SPANISH]:
      "¡Genial! Has adquirido [credits_amount] créditos, ya puedes disfrutar de tus nuevos créditos, recuerda usarlos antes de [expiration_date] para no dejarlos vencer.",
    [Language.PORTUGUESE]:
      "Ótimo! Você adquiriu [credits_amount] créditos, agora pode aproveitar seus novos créditos, lembre-se de usá-los antes de [expiration_date] para não expirarem.",
  },
  "credits-cancel-description": {
    [Language.ENGLISH]:
      "The purchase of [credits_amount] credits could not be completed. No charges have been made.",
    [Language.SPANISH]:
      "No se pudo completar la compra de [credits_amount] créditos. No se ha realizado ningún cargo.",
    [Language.PORTUGUESE]:
      "A compra de [credits_amount] créditos não pôde ser concluída. Nenhuma cobrança foi realizada.",
  },
  back: {
    [Language.ENGLISH]: "Back",
    [Language.SPANISH]: "Atrás",
    [Language.PORTUGUESE]: "Voltar",
  },
  cost: {
    [Language.ENGLISH]: "Cost",
    [Language.SPANISH]: "Costo",
    [Language.PORTUGUESE]: "Custo",
  },
  "upload-photo": {
    [Language.ENGLISH]: "Upload photo",
    [Language.SPANISH]: "Subir foto",
    [Language.PORTUGUESE]: "Enviar foto",
  },
  link: {
    [Language.ENGLISH]: "Link",
    [Language.SPANISH]: "Link",
    [Language.PORTUGUESE]: "Link",
  },
  "increase-your-revenue-with-complementary-products": {
    [Language.ENGLISH]: "Increase your revenue with complementary products",
    [Language.SPANISH]: "Aumenta tu facturación con productos complementarios",
    [Language.PORTUGUESE]: "Aumente sua receita com produtos complementares",
  },
  "add-order-bump": {
    [Language.ENGLISH]: "Add order bump",
    [Language.SPANISH]: "Agregar order bump",
    [Language.PORTUGUESE]: "Adicionar order bump",
  },
  "what-is-an-order-bump": {
    [Language.ENGLISH]: "What is an order bump?",
    [Language.SPANISH]: "¿Qué es un order bump?",
    [Language.PORTUGUESE]: "O que é um order bump?",
  },
  "add-upsell": {
    [Language.ENGLISH]: "Add upsell",
    [Language.SPANISH]: "Agregar upsell",
    [Language.PORTUGUESE]: "Adicionar upsell",
  },
  "what-is-an-upsell": {
    [Language.ENGLISH]: "What is an upsell?",
    [Language.SPANISH]: "¿Qué es un upsell?",
    [Language.PORTUGUESE]: "O que é um upsell?",
  },
  "only-a-few-steps-left": {
    [Language.ENGLISH]: "Only a few steps left",
    [Language.SPANISH]: "Falta muy poco",
    [Language.PORTUGUESE]: "Falta pouco",
  },
  "generate-with-ai": {
    [Language.ENGLISH]: "Generate with AI",
    [Language.SPANISH]: "Generar con IA",
    [Language.PORTUGUESE]: "Gerar com IA",
  },
  warranty: {
    [Language.ENGLISH]: "Warranty",
    [Language.SPANISH]: "Garantía",
    [Language.PORTUGUESE]: "Garantia",
  },
  "load-a-product-to-create-your-page": {
    [Language.ENGLISH]: "Load a product to ",
    [Language.SPANISH]: "Carga un producto para ",
    [Language.PORTUGUESE]: "Carregue um produto para ",
  },
  "create-your-page": {
    [Language.ENGLISH]: "create your page",
    [Language.SPANISH]: "crear tu página",
    [Language.PORTUGUESE]: "criar sua página",
  },
  "no-previous-products-available": {
    [Language.ENGLISH]: "No previous products available",
    [Language.SPANISH]: "No hay productos previos disponibles",
    [Language.PORTUGUESE]: "Nenhum produto anterior disponível",
  },
  "select-one-or-more-sales-angles": {
    [Language.ENGLISH]: "Select one or more sales angles",
    [Language.SPANISH]: "Selecciona uno o varios ángulos de venta",
    [Language.PORTUGUESE]: "Selecione um ou mais ângulos de venda",
  },
  "we-will-create-a-page-with-each-selected-sales-angle": {
    [Language.ENGLISH]: "We will create a page with each selected sales angle",
    [Language.SPANISH]: "Crearemos una página con cada ángulo seleccionado",
    [Language.PORTUGUESE]: "Criaremos uma página com cada ângulo selecionado",
  },
  "enter-custom-sales-angle": {
    [Language.ENGLISH]: "Enter custom sales angle",
    [Language.SPANISH]: "Ingresar ángulo personalizado",
    [Language.PORTUGUESE]: "Inserir ângulo personalizado",
  },
  "create-page": {
    [Language.ENGLISH]: "Create page",
    [Language.SPANISH]: "Crear página",
    [Language.PORTUGUESE]: "Criar página",
  },
  "survey-title": {
    [Language.ENGLISH]: "Answer a few questions to personalize your account",
    [Language.SPANISH]: "Responde unas preguntas para personalizar tu cuenta",
    [Language.PORTUGUESE]:
      "Responda algumas perguntas para personalizar sua conta",
  },
  "start-survey": {
    [Language.ENGLISH]: "Start survey",
    [Language.SPANISH]: "Comenzar",
    [Language.PORTUGUESE]: "Iniciar",
  },
  "write-your-answer-here": {
    [Language.ENGLISH]: "Write your answer here",
    [Language.SPANISH]: "Escribe tu respuesta aquí",
    [Language.PORTUGUESE]: "Escreva sua resposta aqui",
  },
  "go-to-account": {
    [Language.ENGLISH]: "Go to my account",
    [Language.SPANISH]: "Ir a mi cuenta",
    [Language.PORTUGUESE]: "Ir para minha conta",
  },
  "all-set": {
    [Language.ENGLISH]: "All set",
    [Language.SPANISH]: "Todo listo",
    [Language.PORTUGUESE]: "Tudo pronto",
  },










  // SURVEY TRANSLATIONS
  "¿Cual es tu numero de celular?": {
    [Language.ENGLISH]: "What is your phone number?",
    [Language.SPANISH]: "¿Cuál es tu número de teléfono?",
    [Language.PORTUGUESE]: "Qual é seu número de telefone?",
  },

  "Asegurate de agregar el prefijo de tu pais (ejemplo: +57 3xxxxxx)": {
    [Language.ENGLISH]:
      "Make sure to add the prefix of your country (example: +57 3xxxxxx)",
    [Language.SPANISH]:
      "Asegúrate de agregar el prefijo de tu país (ejemplo: +57 3xxxxxx)",
    [Language.PORTUGUESE]:
      "Certifique-se de adicionar o prefixo do seu país (exemplo: +57 3xxxxxx)",
  },

  "¿Ya has tenido ventas online?": {
    [Language.ENGLISH]: "Have you had online sales before?",
    [Language.SPANISH]: "¿Ya has tenido ventas online?",
    [Language.PORTUGUESE]: "Você já teve vendas online?",
  },

  "¿Por qué medios has vendido?": {
    [Language.ENGLISH]: "Which channels have you sold through?",
    [Language.SPANISH]: "¿Por qué medios has vendido?",
    [Language.PORTUGUESE]: "Por quais canais você vendeu?",
  },

  "Puedes seleccionar varios": {
    [Language.ENGLISH]: "You can select multiple options",
    [Language.SPANISH]: "Puedes seleccionar varios",
    [Language.PORTUGUESE]: "Você pode selecionar várias opções",
  },

  "¿Vendes en tienda física?": {
    [Language.ENGLISH]: "Do you sell in a physical store?",
    [Language.SPANISH]: "¿Vendes en tienda física?",
    [Language.PORTUGUESE]: "Você vende em loja física?",
  },

  "¿Cuánto vendes al mes?": {
    [Language.ENGLISH]: "How much do you sell per month?",
    [Language.SPANISH]: "¿Cuánto vendes al mes?",
    [Language.PORTUGUESE]: "Quanto você vende por mês?",
  },

  "Aproximadamente, en pesos colombianos": {
    [Language.ENGLISH]: "Approximately, in Colombian pesos",
    [Language.SPANISH]: "Aproximadamente, en pesos colombianos",
    [Language.PORTUGUESE]: "Aproximadamente, em pesos colombianos",
  },

  "¿Cuántos productos has vendido?": {
    [Language.ENGLISH]: "How many products have you sold?",
    [Language.SPANISH]: "¿Cuántos productos has vendido?",
    [Language.PORTUGUESE]: "Quantos produtos você vendeu?",
  },

  "Productos diferentes que ofreces": {
    [Language.ENGLISH]: "Different products you offer",
    [Language.SPANISH]: "Productos diferentes que ofreces",
    [Language.PORTUGUESE]: "Produtos diferentes que você oferece",
  },

  "¿Qué productos vendes?": {
    [Language.ENGLISH]: "What products do you sell?",
    [Language.SPANISH]: "¿Qué productos vendes?",
    [Language.PORTUGUESE]: "Quais produtos você vende?",
  },

  "Cuales productos ofreces": {
    [Language.ENGLISH]: "Which products you offer",
    [Language.SPANISH]: "Cuales productos ofreces",
    [Language.PORTUGUESE]: "Quais produtos você oferece",
  },

  "¿Qué crees que te ha hecho falta?": {
    [Language.ENGLISH]: "What do you think you’ve been missing?",
    [Language.SPANISH]: "¿Qué crees que te ha hecho falta?",
    [Language.PORTUGUESE]: "O que você acha que está faltando?",
  },

  "Para empezar a vender online": {
    [Language.ENGLISH]: "To start selling online",
    [Language.SPANISH]: "Para empezar a vender online",
    [Language.PORTUGUESE]: "Para começar a vender online",
  },

  "¿Por qué decidiste comprar Fluxi?": {
    [Language.ENGLISH]: "Why did you decide to buy Fluxi?",
    [Language.SPANISH]: "¿Por qué decidiste comprar Fluxi?",
    [Language.PORTUGUESE]: "Por que você decidiu comprar o Fluxi?",
  },

  "Cuéntanos qué te motivó a elegir nuestra plataforma": {
    [Language.ENGLISH]: "Tell us what motivated you to choose our platform",
    [Language.SPANISH]: "Cuéntanos qué te motivó a elegir nuestra plataforma",
    [Language.PORTUGUESE]:
      "Conte-nos o que motivou você a escolher nossa plataforma",
  },

  "Todo listo": {
    [Language.ENGLISH]: "All set",
    [Language.SPANISH]: "Todo listo",
    [Language.PORTUGUESE]: "Tudo pronto",
  },
  Sí: {
    [Language.ENGLISH]: "Yes",
    [Language.SPANISH]: "Sí",
    [Language.PORTUGUESE]: "Sim",
  },

  No: {
    [Language.ENGLISH]: "No",
    [Language.SPANISH]: "No",
    [Language.PORTUGUESE]: "Não",
  },

  Whatsapp: {
    [Language.ENGLISH]: "Whatsapp",
    [Language.SPANISH]: "Whatsapp",
    [Language.PORTUGUESE]: "Whatsapp",
  },

  "Página web": {
    [Language.ENGLISH]: "Website",
    [Language.SPANISH]: "Página web",
    [Language.PORTUGUESE]: "Site",
  },

  "Tienda física": {
    [Language.ENGLISH]: "Physical store",
    [Language.SPANISH]: "Tienda física",
    [Language.PORTUGUESE]: "Loja física",
  },

  "1": {
    [Language.ENGLISH]: "1",
    [Language.SPANISH]: "1",
    [Language.PORTUGUESE]: "1",
  },

  "10": {
    [Language.ENGLISH]: "10",
    [Language.SPANISH]: "10",
    [Language.PORTUGUESE]: "10",
  },

  "50": {
    [Language.ENGLISH]: "50",
    [Language.SPANISH]: "50",
    [Language.PORTUGUESE]: "50",
  },

  "100": {
    [Language.ENGLISH]: "100",
    [Language.SPANISH]: "100",
    [Language.PORTUGUESE]: "100",
  },

  "Mejor producto": {
    [Language.ENGLISH]: "Better product",
    [Language.SPANISH]: "Mejor producto",
    [Language.PORTUGUESE]: "Produto melhor",
  },

  "Mejor precio": {
    [Language.ENGLISH]: "Better price",
    [Language.SPANISH]: "Mejor precio",
    [Language.PORTUGUESE]: "Preço melhor",
  },

  "Mejor contenido en redes sociales": {
    [Language.ENGLISH]: "Better social media content",
    [Language.SPANISH]: "Mejor contenido en redes sociales",
    [Language.PORTUGUESE]: "Melhor conteúdo nas redes sociais",
  },

  "Mejor página web": {
    [Language.ENGLISH]: "Better website",
    [Language.SPANISH]: "Mejor página web",
    [Language.PORTUGUESE]: "Site melhor",
  },

  "No sé": {
    [Language.ENGLISH]: "I don't know",
    [Language.SPANISH]: "No sé",
    [Language.PORTUGUESE]: "Não sei",
  },

  "$1 millón": {
    [Language.ENGLISH]: "$1 million COP",
    [Language.SPANISH]: "$1 millón",
    [Language.PORTUGUESE]: "1 milhão COP",
  },

  "$10 millones": {
    [Language.ENGLISH]: "$10 million COP",
    [Language.SPANISH]: "$10 millones",
    [Language.PORTUGUESE]: "10 milhões COP",
  },

  "$50 millones": {
    [Language.ENGLISH]: "$50 million COP",
    [Language.SPANISH]: "$50 millones",
    [Language.PORTUGUESE]: "50 milhões COP",
  },

  "$100 millones": {
    [Language.ENGLISH]: "$100 million COP",
    [Language.SPANISH]: "$100 millones",
    [Language.PORTUGUESE]: "100 milhões COP",
  },

  "$500 millones": {
    [Language.ENGLISH]: "$500 million COP",
    [Language.SPANISH]: "$500 millones",
    [Language.PORTUGUESE]: "500 milhões COP",
  },

  "describe-your-custom-sales-angle-placeholder-manual-entry": {
    [Language.ENGLISH]: "Describe your custom sales angle...",
    [Language.SPANISH]: "Escribe tu angulo de venta...",
    [Language.PORTUGUESE]: "Descreva seu ângulo de venda personalizado...",
  },
  "add": {
    [Language.ENGLISH]: "Add",
    [Language.SPANISH]: "Agregar",
    [Language.PORTUGUESE]: "Adicionar",
  },
  "counter-delivery": {
    [Language.ENGLISH]: "Cash on payment",
    [Language.SPANISH]: "Contra entrega",
    [Language.PORTUGUESE]: "Entrega contra",
  },
  "you-must-spend-these-credits-before": {
    [Language.ENGLISH]: "You must spend these credits before",
    [Language.SPANISH]: "Debes gastar estos créditos antes del",
    [Language.PORTUGUESE]: "Você deve gastar esses créditos antes do",
  },
  "when-your-credits-will-be-renewed": {
    [Language.ENGLISH]: "when your credits will be renewed",
    [Language.SPANISH]: "cuando se te renovarán los créditos",
    [Language.PORTUGUESE]: "quando seus créditos serão renovados",
  },
  "Plan Básico": {
    [Language.ENGLISH]: "Basic Plan",
    [Language.SPANISH]: "Plan Básico",
    [Language.PORTUGUESE]: "Plano Básico",
  },
  "Plan Medio": {
    [Language.ENGLISH]: "Medium Plan",
    [Language.SPANISH]: "Plan Medio",
    [Language.PORTUGUESE]: "Plano Médio",
  },
  "Plan Avanzado": {
    [Language.ENGLISH]: "Advanced Plan",
    [Language.SPANISH]: "Plan Avanzado",
    [Language.PORTUGUESE]: "Plano Avançado",
  },
  "Plan Master": {
    [Language.ENGLISH]: "Master Plan",
    [Language.SPANISH]: "Plan Master",
    [Language.PORTUGUESE]: "Plano Master",
  },
  "canada": {
    [Language.ENGLISH]: "Canada",
    [Language.SPANISH]: "Canada",
    [Language.PORTUGUESE]: "Canadá",
  },
};
